/*jshint -W069 */
/*global angular:false */
angular.module('leanlaw.core')
    .factory('leanLawApi', ['$q', '$http', '$rootScope', 'leanLawAuth', 'leanLawAuthenticate', function($q, $http, $rootScope, leanLawAuth, leanLawAuthenticate) {
        'use strict';

        var auth = leanLawAuthenticate.authenticate;

        /**
         *
         * @class leanLawApi
         * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
         * @param {string} [domainOrOptions.domain] - The project domain
         * @param {string} [domainOrOptions.cache] - An angularjs cache implementation
         * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
         * @param {string} [cache] - An angularjs cache implementation
         */
        var leanLawApi = (function() {
            function leanLawApi(options, cache) {
                this.domain = leanLawAuth.domain + '/v1';
                if (!this.domain || this.domain.length === 0) {
                    throw new Error('Domain parameter must be specified as a string.');
                }
                cache = cache || ((typeof options === 'object') ? options.cache : cache);
                this.cache = cache;
            }

            leanLawApi.prototype.$on = function($scope, path, handler) {
                var url = domain + path;
                $scope.$on(url, function() {
                    handler();
                });
                return this;
            };

            leanLawApi.prototype.$broadcast = function(path) {
                var url = domain + path;
                //cache.remove(url);
                $rootScope.$broadcast(url);
                return this;
            };

            leanLawApi.transformRequest = function(obj) {
                var str = [];
                for (var p in obj) {
                    var val = obj[p];
                    if (angular.isArray(val)) {
                        val.forEach(function(val) {
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(val));
                        });
                    } else {
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(val));
                    }
                }
                return str.join("&");
            };

            /**
             *
             * @method
             * @name leanLawApi#portalGetClient
             *
             */
            leanLawApi.prototype.portalGetClient = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/portal/client';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#portalGetAccount
             *
             */
            leanLawApi.prototype.portalGetAccount = function(parameters) {
              if (parameters === undefined) {
                  parameters = {};
              }
              var deferred = $q.defer();

              var domain = this.domain;
              var path = '/portal/account';

              var body;
              var queryParameters = {};
              var headers = {};
              var form = {};

              if (parameters.$queryParameters) {
                  Object.keys(parameters.$queryParameters)
                      .forEach(function(parameterName) {
                          var parameter = parameters.$queryParameters[parameterName];
                          queryParameters[parameterName] = parameter;
                      });
              }

              var url = domain + path;
              var cached = parameters.$cache && parameters.$cache.get(url);
              if (cached !== undefined && parameters.$refresh !== true) {
                  deferred.resolve(cached);
                  return deferred.promise;
              }
              var options = {
                  timeout: parameters.$timeout,
                  method: 'GET',
                  url: url,
                  params: queryParameters,
                  data: body,
                  headers: headers
              };
              if (leanLawAuth.source) {
                  options.headers['x-leanlaw-source'] = leanLawAuth.source;
              }
              queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                  options.headers['x-leanlaw-tag'] = parameters['createTag'];
              }
              if (Object.keys(form).length > 0) {
                  options.data = form;
                  options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                  options.transformRequest = leanLawApi.transformRequest;
              }

              auth().then(function(authResult) {
                  if (authResult?.token) {
                      options.headers['Authorization'] = 'Bearer ' + authResult.token;
                  }
                  $http(options).then(function(response) {
                      if (response.status >= 400) {
                          deferred.reject({
                              status: response.status,
                              header: response.headers,
                              config: response.config,
                              body: response.data
                          });
                          return;
                      }
                      return deferred.resolve(response.data);
                      if (parameters.$cache !== undefined) {
                          parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                      }
                  }, function(response) {
                      return deferred.reject({
                          status: response.status,
                          headers: response.headers,
                          config: response.config,
                          body: response.data
                      });
                  });
              }, function(error) {
                  deferred.reject({
                      status: error
                  });
              });

              return deferred.promise;
          };

          leanLawApi.prototype.listCustomFields = function(parameters) {
            if (parameters === undefined) {
                parameters = {};
            }
            var deferred = $q.defer();

            var domain = this.domain;
            var path = '/customfields/options';

            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};

            if (parameters.$queryParameters) {
                Object.keys(parameters.$queryParameters)
                    .forEach(function(parameterName) {
                        var parameter = parameters.$queryParameters[parameterName];
                        queryParameters[parameterName] = parameter;
                    });
            }

            var url = domain + path;
            var cached = parameters.$cache && parameters.$cache.get(url);
            if (cached !== undefined && parameters.$refresh !== true) {
                deferred.resolve(cached);
                return deferred.promise;
            }
            var options = {
                timeout: parameters.$timeout,
                method: 'GET',
                url: url,
                params: queryParameters,
                data: body,
                headers: headers
            };
            if (leanLawAuth.source) {
                options.headers['x-leanlaw-source'] = leanLawAuth.source;
            }
            queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                options.headers['x-leanlaw-tag'] = parameters['createTag'];
            }
            if (Object.keys(form).length > 0) {
                options.data = form;
                options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                options.transformRequest = leanLawApi.transformRequest;
            }

            auth().then(function(authResult) {
                if (authResult?.token) {
                    options.headers['Authorization'] = 'Bearer ' + authResult.token;
                }
                $http(options).then(function(response) {
                    if (response.status >= 400) {
                        deferred.reject({
                            status: response.status,
                            header: response.headers,
                            config: response.config,
                            body: response.data
                        });
                        return;
                    }
                    return deferred.resolve(response.data);
                    if (parameters.$cache !== undefined) {
                        parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                    }
                }, function(response) {
                    return deferred.reject({
                        status: response.status,
                        headers: response.headers,
                        config: response.config,
                        body: response.data
                    });
                });
            }, function(error) {
                deferred.reject({
                    status: error
                });
            });

            return deferred.promise;
        };
            /**
             *
             * @method
             * @name leanLawApi#portalGetActivity
             *
             */
            leanLawApi.prototype.portalGetActivity = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/portal/activity';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };

            /**
             * List of QBO vendors
             * @method
             * @name leanLawApi#accountingListVendors
             *
             */
            leanLawApi.prototype.accountingListVendors = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/vendors';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };

            /**
             * Call endpoint to create a new vendor identical to firm
             * @method
             * @name leanLawApi#accountingCreateFirmVendor
             *
             */
            leanLawApi.prototype.accountingCreateFirmVendor = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/vendors';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };


            /**
             * Get account and company info for the currently logged in user
             * @method
             * @name leanLawApi#getMe
             *
             */
            leanLawApi.prototype.getMe = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/me';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                options.headers['x-leanlaw-timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update account
             * @method
             * @name leanLawApi#updateMe
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateMe = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/me';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * List the accounts that I have access to
             * @method
             * @name leanLawApi#listMyAccounts
             *
             */
            leanLawApi.prototype.listMyAccounts = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/me/accounts';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };

            /**
             * Get current company info
             * @method
             * @name leanLawApi#getMyCompany
             *
             */
            leanLawApi.prototype.getMyCompany = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/me/company';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update my company info
             * @method
             * @name leanLawApi#updateMyCompany
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateMyCompany = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/me/company';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Complete registration of company
             * @method
             * @name leanLawApi#registerCompany
             * @param {} body -
             *
             */
            leanLawApi.prototype.registerCompany = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/me/company/register';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get next reference for clients and matters
             * @method
             * @name leanLawApi#getMyCompanyReferences
             * @param {string} clientId -
             *
             */
            leanLawApi.prototype.getMyCompanyReferences = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/me/company/references';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['clientId'] !== undefined) {
                    queryParameters['clientId'] = parameters['clientId'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Resets all the company references so that they match the id pattern
             * @method
             * @name leanLawApi#updateMyCompanyReferences
             *
             */
            leanLawApi.prototype.updateMyCompanyReferences = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/me/company/references';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#changeMyLogin
             *
             */
            leanLawApi.prototype.changeMyLogin = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/me/login';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Reset the current company in LeanLaw (only available to test accounts)
             * @method
             * @name leanLawApi#resetCompany
             * @param {boolean} matters -
             * @param {boolean} entries -
             * @param {boolean} test -
             *
             */
            leanLawApi.prototype.resetCompany = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/me/reset';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['matters'] !== undefined) {
                    queryParameters['matters'] = parameters['matters'];
                }

                if (parameters['entries'] !== undefined) {
                    queryParameters['entries'] = parameters['entries'];
                }

                if (parameters['test'] !== undefined) {
                    queryParameters['test'] = parameters['test'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#listOnboards
             *
             */
            leanLawApi.prototype.listOnboards = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/onboards';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };

            /**
             * Get company info
             * @method
             * @name leanLawApi#getCompany
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getCompany = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/companies/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update company info
             * @method
             * @name leanLawApi#updateCompany
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateCompany = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/companies/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of api keys associated with the company
             * @method
             * @name leanLawApi#listApiKeys
             *
             */
            leanLawApi.prototype.listApiKeys = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/apikeys';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Generate an api key for the company
             * @method
             * @name leanLawApi#generateApiKey
             * @param {} body -
             *
             */
            leanLawApi.prototype.generateApiKey = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/apikeys';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update an api key
             * @method
             * @name leanLawApi#updateAccount
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateApiKey = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/apikeys/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };

            /**
             * delete an api key
             * @method
             * @name leanLawApi#deleteApiKey
             * @param {string} id -
             *
             */
            leanLawApi.prototype.deleteApiKey = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/apikeys/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'DELETE',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of accounts for current company
             * @method
             * @name leanLawApi#listAccounts
             * @param {string} status -
             * @param {boolean} originating -
             *
             */
            leanLawApi.prototype.listAccounts = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounts';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['status'] !== undefined) {
                    queryParameters['status'] = parameters['status'];
                }

                if (parameters['originating'] !== undefined) {
                    queryParameters['originating'] = parameters['originating'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Invite a user
             * @method
             * @name leanLawApi#createAccount
             * @param {} body -
             *
             */
            leanLawApi.prototype.createAccount = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounts';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get a specific account
             * @method
             * @name leanLawApi#getAccount
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getAccount = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounts/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update an account
             * @method
             * @name leanLawApi#updateAccount
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateAccount = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounts/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Cancel invitation or remove account (and optionally transfer items to someone else)
             * @method
             * @name leanLawApi#deleteAccount
             * @param {string} id -
             * @param {string} transferAccount -
             *
             */
            leanLawApi.prototype.deleteAccount = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounts/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['transferAccount'] !== undefined) {
                    queryParameters['transferAccount'] = parameters['transferAccount'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'DELETE',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get Account State
             * @method
             * @name leanLawApi#getAccountState
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getAccountState = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounts/{id}/state';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Disable or re-enable an account
             * @method
             * @name leanLawApi#archiveAccount
             * @param {string} id -
             * @param {boolean} archive -
             *
             */
            leanLawApi.prototype.archiveAccount = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounts/{id}/archive';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['archive'] !== undefined) {
                    queryParameters['archive'] = parameters['archive'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Reinvite a user
             * @method
             * @name leanLawApi#inviteAccount
             * @param {string} id -
             *
             */
            leanLawApi.prototype.inviteAccount = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounts/{id}/invite';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * List of users to include on a matter
             * @method
             * @name leanLawApi#listAccountMatterUsers
             * @param {string} id -
             *
             */
            leanLawApi.prototype.listAccountMatterUsers = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounts/{id}/matterUsers';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Email a user
             * @method
             * @name leanLawApi#emailAccount
             * @param {string} id -
             * @param {boolean} invite -
             *
             */


      leanLawApi.prototype.trustDisconnect = function (parameters) {
        if (parameters === undefined) {
          parameters = {};
        }
        var deferred = $q.defer();

        var domain = this.domain;
        var path = '/me/company/trusts/{trustId}/disconnect';

        var body;
        var queryParameters = {};
        var headers = {};
        var form = {};


        path = path.replace('{trustId}', parameters['trustId']);

        if (parameters['body'] !== undefined) {
          body = parameters['body'];
        }

        if (parameters.$queryParameters) {
          Object.keys(parameters.$queryParameters)
            .forEach(function (parameterName) {
              var parameter = parameters.$queryParameters[parameterName];
              queryParameters[parameterName] = parameter;
            });
        }

        var url = domain + path;
        var options = {
          timeout: parameters.$timeout,
          method: 'POST',
          url: url,
          params: queryParameters,
          data: body,
          headers: headers
        };
        if (leanLawAuth.source) {
          options.headers['x-leanlaw-source'] = leanLawAuth.source;
        }
        queryParameters['timeOffset'] = new Date().getTimezoneOffset();
        if (parameters['createTag']) {
          options.headers['x-leanlaw-tag'] = parameters['createTag'];
        }
        if (Object.keys(form).length > 0) {
          options.data = form;
          options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
          options.transformRequest = leanLawApi.transformRequest;
        }

        auth().then(function (authResult) {
          if (authResult?.token) {
            options.headers['Authorization'] = 'Bearer ' + authResult.token;
          }
          $http(options).then(function (response) {
            if (response.status >= 400) {
              deferred.reject({
                status: response.status,
                header: response.headers,
                config: response.config,
                body: response.data
              });
              return;
            }
            return deferred.resolve(response.data);
            if (parameters.$cache !== undefined) {
              parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
            }
          }, function (response) {
            return deferred.reject({
              status: response.status,
              headers: response.headers,
              config: response.config,
              body: response.data
            });
          });
        }, function (error) {
          deferred.reject({
            status: error
          });
        });

        return deferred.promise;
      };

      leanLawApi.prototype.trustCheck = function (parameters) {
        if (parameters === undefined) {
          parameters = {};
        }
        var deferred = $q.defer();

        var domain = this.domain;
        var path = '/me/company/trusts/{trustId}';

        var body;
        var queryParameters = {};
        var headers = {};
        var form = {};


        path = path.replace('{trustId}', parameters['trustId']);

        if (parameters['body'] !== undefined) {
          body = parameters['body'];
        }

        if (parameters.$queryParameters) {
          Object.keys(parameters.$queryParameters)
            .forEach(function (parameterName) {
              var parameter = parameters.$queryParameters[parameterName];
              queryParameters[parameterName] = parameter;
            });
        }

        var url = domain + path;
        var options = {
          timeout: parameters.$timeout,
          method: 'GET',
          url: url,
          params: queryParameters,
          data: body,
          headers: headers
        };
        if (leanLawAuth.source) {
          options.headers['x-leanlaw-source'] = leanLawAuth.source;
        }
        queryParameters['timeOffset'] = new Date().getTimezoneOffset();
        if (parameters['createTag']) {
          options.headers['x-leanlaw-tag'] = parameters['createTag'];
        }
        if (Object.keys(form).length > 0) {
          options.data = form;
          options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
          options.transformRequest = leanLawApi.transformRequest;
        }

        auth().then(function (authResult) {
          if (authResult?.token) {
            options.headers['Authorization'] = 'Bearer ' + authResult.token;
          }
          $http(options).then(function (response) {
            if (response.status >= 400) {
              deferred.reject({
                status: response.status,
                header: response.headers,
                config: response.config,
                body: response.data
              });
              return;
            }
            return deferred.resolve(response.data);
            if (parameters.$cache !== undefined) {
              parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
            }
          }, function (response) {
            return deferred.reject({
              status: response.status,
              headers: response.headers,
              config: response.config,
              body: response.data
            });
          });
        }, function (error) {
          deferred.reject({
            status: error
          });
        });

        return deferred.promise;
      };
            leanLawApi.prototype.emailAccount = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounts/{id}/email';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['invite'] !== undefined) {
                    queryParameters['invite'] = parameters['invite'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#getSubscription
             *
             */
            leanLawApi.prototype.getSubscription = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/subscription';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#startSubscription
             * @param {} body -
             *
             */
            leanLawApi.prototype.startSubscription = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/subscription';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#updateSubscription
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateSubscription = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/subscription';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#getSubscriptionCost
             * @param {number} addSeat -
             * @param {number} removeSeat -
             * @param {string} planId -
             *
             */
            leanLawApi.prototype.getSubscriptionCost = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/subscription/cost';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['addSeat'] !== undefined) {
                    queryParameters['addSeat'] = parameters['addSeat'];
                }

                if (parameters['removeSeat'] !== undefined) {
                    queryParameters['removeSeat'] = parameters['removeSeat'];
                }

                if (parameters['planId'] !== undefined) {
                    queryParameters['planId'] = parameters['planId'];
                }

                if (parameters['dealId'] !== undefined) {
                    queryParameters['dealId'] = parameters['dealId'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Validate a coupon
             * @method
             * @name leanLawApi#getSubscriptionCoupon
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getSubscriptionCoupon = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/subscription/coupons/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * List valid product and plans for this customer
             * @method
             * @name leanLawApi#listSubscriptionProducts
             *
             */
            leanLawApi.prototype.listSubscriptionProducts = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/subscription/products';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * List valid payment plans (not plans assigned to this customer)
             * @method
             * @name leanLawApi#listSubscriptionPlans
             *
             */
            leanLawApi.prototype.listSubscriptionPlans = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/subscription/plans';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#updateSubscriptionPlan
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateSubscriptionPlan = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/subscription/plans';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#listSubscriptionInvoices
             *
             */
            leanLawApi.prototype.listSubscriptionInvoices = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/subscription/invoices';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#createCheckoutSession
             * @param {string} token -
             *
             */
            leanLawApi.prototype.createCheckoutSession = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/subscription/checkout-session';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['token'] !== undefined) {
                    queryParameters['token'] = parameters['token'];
                }

                if (parameters['types'] !== undefined) {
                  queryParameters['types'] = parameters['types'];
              }
              if (parameters['redirect'] !== undefined) {
                queryParameters['redirect'] = parameters['redirect'];
            }


                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#updateSubscriptionCard
             * @param {string} token -
             *
             */
            leanLawApi.prototype.updateSubscriptionCard = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/subscription/card';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['token'] !== undefined) {
                    queryParameters['token'] = parameters['token'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Search across clients/matters etc, for conflict check
             * @method
             * @name leanLawApi#search
             * @param {string} query -
             * @param {boolean} matters -
             * @param {boolean} clients -
             * @param {boolean} entries -
             * @param {boolean} expenses -
             * @param {boolean} invoices -
             *
             */
            leanLawApi.prototype.search = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/search';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['query'] !== undefined) {
                    queryParameters['query'] = parameters['query'];
                }

                if (parameters['query'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: query'));
                    return deferred.promise;
                }

                if (parameters['matters'] !== undefined) {
                    queryParameters['matters'] = parameters['matters'];
                }

                if (parameters['clients'] !== undefined) {
                    queryParameters['clients'] = parameters['clients'];
                }

                if (parameters['entries'] !== undefined) {
                    queryParameters['entries'] = parameters['entries'];
                }

                if (parameters['expenses'] !== undefined) {
                    queryParameters['expenses'] = parameters['expenses'];
                }

                if (parameters['invoices'] !== undefined) {
                    queryParameters['invoices'] = parameters['invoices'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Search across clients/matters etc, for conflict check
             * @method
             * @name leanLawApi#search
             * @param {string} query -
             * @param {boolean} matters -
             * @param {boolean} clients -
             * @param {boolean} entries -
             * @param {boolean} expenses -
             * @param {boolean} invoices -
             *
             */
            leanLawApi.prototype.search = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/search';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['query'] !== undefined) {
                    queryParameters['query'] = parameters['query'];
                }

                if (parameters['query'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: query'));
                    return deferred.promise;
                }

                if (parameters['matters'] !== undefined) {
                    queryParameters['matters'] = parameters['matters'];
                }

                if (parameters['clients'] !== undefined) {
                    queryParameters['clients'] = parameters['clients'];
                }

                if (parameters['entries'] !== undefined) {
                    queryParameters['entries'] = parameters['entries'];
                }

                if (parameters['expenses'] !== undefined) {
                    queryParameters['expenses'] = parameters['expenses'];
                }

                if (parameters['invoices'] !== undefined) {
                    queryParameters['invoices'] = parameters['invoices'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * List of clients
             * @method
             * @name leanLawApi#listClients
             * @param {string} status - Determines which clients to return, active, archived, pending or all. Default 'active'.

             * @param {string} scope - Determines which clients are returned.
            * 'involved' returns clients that have matters where the current account are assigned as responsible attorney or contributor.
            * 'access' returns clients that have matters where the current account has access (includes involved matters and non-restricted matters) and also clients that don't have any matters attached (default).
            * 'all' returns all clients.

             * @param {string} scopeAccount -
             * @param {string} matters - Determines whether result includes a list of matters for each client, or just the list of clients. Default 'include'.
             * @param {string} contact -
             * @param {string} search - Search string (for type-ahead)
             * @param {string} orphan -
             *
             */
            leanLawApi.prototype.listClients = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['status'] !== undefined) {
                    queryParameters['status'] = parameters['status'];
                }

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters['matters'] !== undefined) {
                    queryParameters['matters'] = parameters['matters'];
                }

                if (parameters['contact'] !== undefined) {
                    queryParameters['contact'] = parameters['contact'];
                }

                if (parameters['search'] !== undefined) {
                    queryParameters['search'] = parameters['search'];
                }

                if (parameters['orphan'] !== undefined) {
                    queryParameters['orphan'] = parameters['orphan'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create new client
             * @method
             * @name leanLawApi#createClient
             * @param {} body -
             *
             */
            leanLawApi.prototype.createClient = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get a client
             * @method
             * @name leanLawApi#getClient
             * @param {string} id -
             * @param {string} matters -
             * @param {string} scope - if matters are included, this determines which ones are included (see /clients)
             * @param {string} scopeAccount -
             * @param {string} status -
             *
             */
            leanLawApi.prototype.getClient = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['matters'] !== undefined) {
                    queryParameters['matters'] = parameters['matters'];
                }

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters['status'] !== undefined) {
                    queryParameters['status'] = parameters['status'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update client
             * @method
             * @name leanLawApi#updateClient
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateClient = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Delete a client
             * @method
             * @name leanLawApi#deleteClient
             * @param {string} id -
             *
             */
            leanLawApi.prototype.deleteClient = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'DELETE',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get planner entries for the client
             * @method
             * @name leanLawApi#listClientEntries
             * @param {string} id -
             * @param {string} startDate -
             * @param {string} endDate -
             * @param {integer} timeOffset -
             * @param {string} billable -
             * @param {string} account - Account id
             * @param {string} include - See /entries
             * @param {string} billingType -
             * @param {string} status -
             *
             */
            leanLawApi.prototype.listClientEntries = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}/entries';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['startDate'] !== undefined) {
                    queryParameters['startDate'] = parameters['startDate'];
                }

                if (parameters['endDate'] !== undefined) {
                    queryParameters['endDate'] = parameters['endDate'];
                }

                if (queryParameters['timeOffset'] !== undefined) {
                    queryqueryParameters['timeOffset'] = queryParameters['timeOffset'];
                }

                if (parameters['billable'] !== undefined) {
                    queryParameters['billable'] = parameters['billable'];
                }

                if (parameters['chargeCompleted'] !== undefined) {
                    queryParameters['chargeCompleted'] = parameters['chargeCompleted'];
                }

                if (parameters['account'] !== undefined) {
                    queryParameters['account'] = parameters['account'];
                }

                if (parameters['include'] !== undefined) {
                    queryParameters['include'] = parameters['include'];
                }

                if (parameters['billingType'] !== undefined) {
                    queryParameters['billingType'] = parameters['billingType'];
                }

                if (parameters['status'] !== undefined) {
                    queryParameters['status'] = parameters['status'];
                }

                if (parameters['mattersIds'] !== undefined) {
                    const matterIdsParam = parameters.mattersIds.map(id => `matterIds=${id}`).join('&');
                    path = path + (path.includes('?') ? '&' : '?') + matterIdsParam;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of expenses for client
             * @method
             * @name leanLawApi#listClientExpenses
             * @param {string} id -
             * @param {string} startDate -
             * @param {string} endDate -
             * @param {string} billable -
             * @param {string} billed -
             * @param {string} scope -
             * @param {string} scopeAccount -
             * @param {string} status -
             *
             */
            leanLawApi.prototype.listClientExpenses = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}/expenses';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['startDate'] !== undefined) {
                    queryParameters['startDate'] = parameters['startDate'];
                }

                if (parameters['endDate'] !== undefined) {
                    queryParameters['endDate'] = parameters['endDate'];
                }

                if (parameters['billable'] !== undefined) {
                    queryParameters['billable'] = parameters['billable'];
                }

                if (parameters['billed'] !== undefined) {
                    queryParameters['billed'] = parameters['billed'];
                }

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters['status'] !== undefined) {
                    queryParameters['status'] = parameters['status'];
                }

                if (parameters['expenseType'] !== undefined) {
                    queryParameters['expenseType'] = parameters['expenseType'];
                }


                if (parameters['customFlag'] !== undefined) {
                    queryParameters['customFlag'] = parameters['customFlag'];
                }


                if (parameters['paid'] !== undefined) {
                    queryParameters['paid'] = parameters['paid'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                if (parameters['mattersIds'] !== undefined) {
                    const matterIdsParam = parameters.mattersIds.map(id => `matterIds=${id}`).join('&');
                    path = path + (path.includes('?') ? '&' : '?') + matterIdsParam;
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#getClientTrust
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getClientTrust = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}/trust';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get accounting information for client
             * @method
             * @name leanLawApi#getClientAccounting
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getClientAccounting = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}/accounting';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update accounting information for client
             * @method
             * @name leanLawApi#updateClientAccounting
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateClientAccounting = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}/accounting';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Deposit money into trust account
             * @method
             * @name leanLawApi#createClientDeposit
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.createClientDeposit = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}/deposit';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Request money for trust account
             * @method
             * @name leanLawApi#createClientTrustRequest
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.createClientTrustRequest = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}/request';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Record payment from client
             * @method
             * @name leanLawApi#createClientPayment
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.createClientPayment = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}/payment';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get billing information for the client
             * @method
             * @name leanLawApi#getClientBilling
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getClientBilling = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}/billing';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update client billing
             * @method
             * @name leanLawApi#updateClientBilling
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateClientBilling = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}/billing';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get matters for client
             * @method
             * @name leanLawApi#listClientMatters
             * @param {string} id - client id
             * @param {string} status - Determines which matters to return, active, pending, archived or all. Default 'active'.
             * @param {string} scope - Determines which matters are returned.
            * 'involved' returns matterrs where the current account are assigned as responsible attorney or contributor.
            * 'access' returns matters where the current account has access (includes involved matters and un-restricted matters) (default).
            * 'all' returns all matters (admin only).

             * @param {string} scopeAccount -
             * @param {string} search - Search string (for type-ahead)
             *
             */
            leanLawApi.prototype.listClientMatters = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}/matters';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['status'] !== undefined) {
                    queryParameters['status'] = parameters['status'];
                }

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters['search'] !== undefined) {
                    queryParameters['search'] = parameters['search'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create new matter
             * @method
             * @name leanLawApi#createClientMatter
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.createClientMatter = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/clients/{id}/matters';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Latest changes to account to help caching on front-end
             * @method
             * @name leanLawApi#getSync
             *
             */
            leanLawApi.prototype.getSync = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/sync';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get matter overview
             * @method
             * @name leanLawApi#getMatterOverview
             *
             */
            leanLawApi.prototype.getMatterOverview = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/overview';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get matters
             * @method
             * @name leanLawApi#listMatters
             * @param {string} status - Determines which matters to return, active, pending, archived or all. Default 'active'.
             * @param {string} scope - Determines which matters are returned.
            * 'primary' returns matters for which I am responsible
            * 'involved' returns matters where the current account are assigned in some role
            * 'access' returns matters where the current account has access (includes involved matters and un-restricted matters) (default).
            * 'all' returns all matters (admin only).

             * @param {string} scopeAccount - Matters from the perspective of this account
             * @param {string} billingType -
             * @param {string} search - Search string (for type-ahead)
             * @param {string} matterTag - Matter tag / Practice area
             *
             */
            leanLawApi.prototype.listMatters = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['status'] !== undefined) {
                    queryParameters['status'] = parameters['status'];
                }

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters['billingType'] !== undefined) {
                    queryParameters['billingType'] = parameters['billingType'];
                }

                if (parameters['search'] !== undefined) {
                    queryParameters['search'] = parameters['search'];
                }

                if (parameters['matterTag'] !== undefined) {
                    queryParameters['matterTag'] = parameters['matterTag'];
                }

                if (parameters['showSecondarySplitMatter'] !== undefined) {
                    queryParameters['showSecondarySplitMatter'] = parameters['showSecondarySplitMatter'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create new matter
             * @method
             * @name leanLawApi#createMatter
             * @param {} body -
             *
             */
            leanLawApi.prototype.createMatter = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get a matter
             * @method
             * @name leanLawApi#getMatter
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getMatter = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Delete a matter
             * @method
             * @name leanLawApi#deleteMatter
             * @param {string} id -
             *
             */
            leanLawApi.prototype.deleteMatter = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'DELETE',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update a matter
             * @method
             * @name leanLawApi#updateMatter
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateMatter = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

            return deferred.promise;
        };
            /**
             * Updates rates for a specific matter
             * @method
             * @name leanLawApi#updateMatterRates
             * @param {string} id - Matter ID
             * @param {object} body - Rate update details including users, billingType, rateGroup, and rateOptions
             *
             */
            leanLawApi.prototype.updateMatterRates = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/rates';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required parameter: id'));
                    return deferred.promise;
                }

                path = path.replace('{id}', parameters['id']);

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
                if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Applies rate updates to multiple matters for a client in one request
             * @method
             * @name leanLawApi#bulkUpdateMatterRates
             * @param {string} clientId - Client ID whose matters should be updated
             * @param {object} body - Rate update details including users, billing, and rate options
             *
             */
            leanLawApi.prototype.bulkUpdateMatterRates = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/client/{clientId}/rates';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['clientId'] === undefined) {
                    deferred.reject(new Error('Missing required parameter: clientId'));
                    return deferred.promise;
                }

                path = path.replace('{clientId}', parameters['clientId']);

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
                if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Additional information for a matter
             * @method
             * @name leanLawApi#getMatterStats
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getMatterStats = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/stats';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of expenses for matter
             * @method
             * @name leanLawApi#listMatterExpenses
             * @param {string} id -
             * @param {string} startDate -
             * @param {string} endDate -
             * @param {string} billable -
             * @param {string} billed -
             * @param {string} status -
             *
             */
            leanLawApi.prototype.listMatterExpenses = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/expenses';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['startDate'] !== undefined) {
                  queryParameters['startDate'] = parameters['startDate'];
                }

                if (parameters['endDate'] !== undefined) {
                    queryParameters['endDate'] = parameters['endDate'];
                }

                if (parameters['billable'] !== undefined) {
                    queryParameters['billable'] = parameters['billable'];
                }

                if (parameters['billed'] !== undefined) {
                    queryParameters['billed'] = parameters['billed'];
                }

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters['status'] !== undefined) {
                    queryParameters['status'] = parameters['status'];
                }

                if (parameters['expenseType'] !== undefined) {
                    queryParameters['expenseType'] = parameters['expenseType'];
                }


                if (parameters['customFlag'] !== undefined) {
                    queryParameters['customFlag'] = parameters['customFlag'];
                }


                if (parameters['paid'] !== undefined) {
                    queryParameters['paid'] = parameters['paid'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create expense for matter
             * @method
             * @name leanLawApi#createMatterExpense
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.createMatterExpense = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/expenses';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update expenses for matter
             * @method
             * @name leanLawApi#updateMatterExpenses
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateMatterExpenses = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/expenses';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get planner entries for the matter
             * @method
             * @name leanLawApi#listMatterEntries
             * @param {string} id -
             * @param {string} startDate -
             * @param {integer} timeOffset -
             * @param {string} endDate -
             * @param {string} billable -
             * @param {string} account - Account id
             * @param {string} include - See /entries
             *
             */
            leanLawApi.prototype.listMatterEntries = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/entries';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['startDate'] !== undefined) {
                    queryParameters['startDate'] = parameters['startDate'];
                }

                if (queryParameters['timeOffset'] !== undefined) {
                    queryqueryParameters['timeOffset'] = queryParameters['timeOffset'];
                }

                if (parameters['endDate'] !== undefined) {
                    queryParameters['endDate'] = parameters['endDate'];
                }

                if (parameters['billable'] !== undefined) {
                    queryParameters['billable'] = parameters['billable'];
                }

                if (parameters['chargeCompleted'] !== undefined) {
                    queryParameters['chargeCompleted'] = parameters['chargeCompleted'];
                }

                if (parameters['account'] !== undefined) {
                    queryParameters['account'] = parameters['account'];
                }

                if (parameters['include'] !== undefined) {
                    queryParameters['include'] = parameters['include'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update all planner entries
             * @method
             * @name leanLawApi#updateMatterEntries
             * @param {string} id -
             * @param {boolean} billable -
             *
             */
            leanLawApi.prototype.updateMatterEntries = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/entries';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['billable'] !== undefined) {
                    queryParameters['billable'] = parameters['billable'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get billing information for the matter
             * @method
             * @name leanLawApi#getMatterBilling
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getMatterBilling = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/billing';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Assign current user to this matter and activate it if it isn't activated
             * @method
             * @name leanLawApi#assignMatter
             * @param {string} id -
             *
             */
            leanLawApi.prototype.assignMatter = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/assign';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#getMatterTrust
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getMatterTrust = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/trust';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get accounting information for matter
             * @method
             * @name leanLawApi#getMatterAccounting
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getMatterAccounting = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/accounting';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update accounting information for a matter (association with Quickbooks)
             * @method
             * @name leanLawApi#updateMatterAccounting
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateMatterAccounting = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/accounting';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Request money for trust account
             * @method
             * @name leanLawApi#createMatterTrustRequest
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.createMatterTrustRequest = function(parameters) {
              if (parameters === undefined) {
                  parameters = {};
              }
              var deferred = $q.defer();

              var domain = this.domain;
              var path = '/matters/{id}/request';

              var body;
              var queryParameters = {};
              var headers = {};
              var form = {};

              path = path.replace('{id}', parameters['id']);

              if (parameters['id'] === undefined) {
                  deferred.reject(new Error('Missing required  parameter: id'));
                  return deferred.promise;
              }

              if (parameters['body'] !== undefined) {
                  body = parameters['body'];
              }

              if (parameters.$queryParameters) {
                  Object.keys(parameters.$queryParameters)
                      .forEach(function(parameterName) {
                          var parameter = parameters.$queryParameters[parameterName];
                          queryParameters[parameterName] = parameter;
                      });
              }

              var url = domain + path;
              var options = {
                  timeout: parameters.$timeout,
                  method: 'POST',
                  url: url,
                  params: queryParameters,
                  data: body,
                  headers: headers
              };
              if (leanLawAuth.source) {
                  options.headers['x-leanlaw-source'] = leanLawAuth.source;
              }
              queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                  options.headers['x-leanlaw-tag'] = parameters['createTag'];
              }
              if (Object.keys(form).length > 0) {
                  options.data = form;
                  options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                  options.transformRequest = leanLawApi.transformRequest;
              }

              auth().then(function(authResult) {
                  if (authResult?.token) {
                      options.headers['Authorization'] = 'Bearer ' + authResult.token;
                  }
                  $http(options).then(function(response) {
                      if (response.status >= 400) {
                          deferred.reject({
                              status: response.status,
                              header: response.headers,
                              config: response.config,
                              body: response.data
                          });
                          return;
                      }
                      return deferred.resolve(response.data);
                      if (parameters.$cache !== undefined) {
                          parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                      }
                  }, function(response) {
                      return deferred.reject({
                          status: response.status,
                          headers: response.headers,
                          config: response.config,
                          body: response.data
                      });
                  });
              }, function(error) {
                  deferred.reject({
                      status: error
                  });
              });

              return deferred.promise;
          };
          /**
             * Deposit money into trust account
             * @method
             * @name leanLawApi#createMatterDeposit
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.createMatterDeposit = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/deposit';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Record payment from matter
             * @method
             * @name leanLawApi#createMatterPayment
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.createMatterPayment = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/payment';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Creates folder in cloud storage for matter. If a folder already exists, this operation won't do anything.
             * @method
             * @name leanLawApi#createMatterFolder
             * @param {string} id -
             *
             */
            leanLawApi.prototype.createMatterFolder = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/folder';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Fixes gmail labels and google drive folders
             * @method
             * @name leanLawApi#updateMatterFolder
             * @param {string} id -
             *
             */
            leanLawApi.prototype.updateMatterFolder = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{id}/folder';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Merge one matter with another. The src is merge into the dest and then the src is deleted. Requires admin priviledges.
             * @method
             * @name leanLawApi#mergeMatters
             * @param {string} dest - The matter id for the destination
             * @param {string} src - The matter id for the source
             *
             */
            leanLawApi.prototype.mergeMatters = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/matters/{dest}/merge/{src}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{dest}', parameters['dest']);

                if (parameters['dest'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: dest'));
                    return deferred.promise;
                }

                path = path.replace('{src}', parameters['src']);

                if (parameters['src'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: src'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get information about a thread such as what matter it is assigned to
             * @method
             * @name leanLawApi#getThread
             * @param {string} id - The email thread id. Alternative to get a thread based on a message id the id can be prefixed with "msg." for example "msg.xxx" where "xxx" is the message id.
             *
             */
            leanLawApi.prototype.getThread = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/threads/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Assign matter to thread
             * @method
             * @name leanLawApi#updateThread
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateThread = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/threads/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of items (email, document, appointments, tasks)
             * @method
             * @name leanLawApi#listItems
             * @param {string} startDate -
             * @param {string} endDate -
             * @param {string} type -
             * @param {string} account -
             *
             */
            leanLawApi.prototype.listItems = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/items';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['startDate'] !== undefined) {
                    queryParameters['startDate'] = parameters['startDate'];
                }

                if (parameters['endDate'] !== undefined) {
                    queryParameters['endDate'] = parameters['endDate'];
                }

                if (parameters['type'] !== undefined) {
                    queryParameters['type'] = parameters['type'];
                }

                if (parameters['account'] !== undefined) {
                    queryParameters['account'] = parameters['account'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * List of timers
             * @method
             * @name leanLawApi#listTimers
             *
             */
            leanLawApi.prototype.listTimers = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/timers';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create timer
             * @method
             * @name leanLawApi#createTimer
             * @param {} body -
             *
             */
            leanLawApi.prototype.createTimer = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/timers';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update timer
             * @method
             * @name leanLawApi#updateTimer
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateTimer = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/timers/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Delete timer
             * @method
             * @name leanLawApi#deleteTimer
             * @param {string} id -
             *
             */
            leanLawApi.prototype.deleteTimer = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/timers/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'DELETE',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Bulk delete timers by date
             * @method
             * @name leanLawApi#bulkDeleteTimers
             * @param {Date} deleteOlderThan - Delete timers created before this date
             *
             */
            leanLawApi.prototype.bulkDeleteTimers = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/timers/bulk-delete';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['deleteOlderThan'] === undefined) {
                    deferred.reject(new Error('Missing required parameter: deleteOlderThan (Date)'));
                    return deferred.promise;
                }

                // Send the date as a query parameter
                queryParameters['deleteOlderThan'] = parameters['deleteOlderThan'];

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
                options.headers['Content-Type'] = 'application/json';
                if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of invoices
             * @method
             * @name leanLawApi#listInvoices
             * @param {integer} offset -
             * @param {integer} limit -
             * @param {string} orderby -
             * @param {string} order -
             * @param {string} processed -
             * @param {string} deliveryType -
             * @param {string} delivered -
             * @param {string} active -
             * @param {string} clientId -
             * @param {string} matterId -
             * @param {boolean} check -
             * @param {string} state -
             * @param {string} scope -
             * @param {string} scopeAccount -
             * @param {string} startDate -
             * @param {string} endDate -
             * @param {string} status -
             *
             */
            leanLawApi.prototype.listInvoices = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['offset'] !== undefined) {
                    queryParameters['offset'] = parameters['offset'];
                }

                if (parameters['limit'] !== undefined) {
                    queryParameters['limit'] = parameters['limit'];
                }

                if (parameters['orderby'] !== undefined) {
                  queryParameters['orderby'] = parameters['orderby'];
              }

                if (parameters['order'] !== undefined) {
                    queryParameters['order'] = parameters['order'];
                }

                if (parameters['processed'] !== undefined) {
                    queryParameters['processed'] = parameters['processed'];
                }

                if (parameters['deliveryType'] !== undefined) {
                    queryParameters['deliveryType'] = parameters['deliveryType'];
                }

                if (parameters['matterTag'] !== undefined) {
                  queryParameters['matterTag'] = parameters['matterTag'];
              }

                if (parameters['delivered'] !== undefined) {
                    queryParameters['delivered'] = parameters['delivered'];
                }

                if (parameters['active'] !== undefined) {
                    queryParameters['active'] = parameters['active'];
                }

                if (parameters['clientId'] !== undefined) {
                    queryParameters['clientId'] = parameters['clientId'];
                }

                if (parameters['matterId'] !== undefined) {
                    queryParameters['matterId'] = parameters['matterId'];
                }

                if (parameters['check'] !== undefined) {
                    queryParameters['check'] = parameters['check'];
                }

                if (parameters['state'] !== undefined) {
                    queryParameters['state'] = parameters['state'];
                }

                if (parameters['billedState'] !== undefined) {
                    queryParameters['billedState'] = parameters['billedState'];
                }

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters['startDate'] !== undefined) {
                    queryParameters['startDate'] = parameters['startDate'];
                }

                if (parameters['endDate'] !== undefined) {
                    queryParameters['endDate'] = parameters['endDate'];
                }

                if (parameters['status'] !== undefined) {
                    queryParameters['status'] = parameters['status'];
                }

                if (parameters['deliveryStatuses'] !== undefined) {
                    if (Array.isArray(parameters['deliveryStatuses'])) {
                        // If parameters['deliveryStatuses'] is an array, create an array of 'deliveryStatuses' keys in queryParameters
                        queryParameters['deliveryStatuses'] = parameters['deliveryStatuses'];
                    } else {
                        // Otherwise, add it as a single key-value pair
                        queryParameters['deliveryStatuses'] = [parameters['deliveryStatuses']];
                    }
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create an invoice
             * @method
             * @name leanLawApi#createInvoice
             * @param {} body -
             *
             */
            leanLawApi.prototype.createInvoice = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Bulk create invoices
             * @method
             * @name leanLawApi#createInvoiceBulk
             * @param {} body -
             *
             */
            leanLawApi.prototype.createInvoiceBulk = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/bulk';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Reformat Existing Invoice
             * @method
             * @name leanLawApi#reformatInvoice
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.reformatInvoice = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}/reformat';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };

            /**
             * Get invoices summary
             * @method
             * @name leanLawApi#getInvoiceSummary
             * @param {string} id - invoice id
             */
            leanLawApi.prototype.getInvoiceSummary = function(parameters) {
              if (parameters === undefined) {
                  parameters = {};
              }
              var deferred = $q.defer();

              var domain = this.domain;
              var path = '/invoices/{id}/summary';

              var body;
              var queryParameters = {};
              var headers = {};
              var form = {};

              path = path.replace('{id}', parameters['id']);

              if (parameters['id'] === undefined) {
                  deferred.reject(new Error('Missing required  parameter: id'));
                  return deferred.promise;
              }

              if (parameters.$queryParameters) {
                  Object.keys(parameters.$queryParameters)
                      .forEach(function(parameterName) {
                          var parameter = parameters.$queryParameters[parameterName];
                          queryParameters[parameterName] = parameter;
                      });
              }

              var url = domain + path;
              var cached = parameters.$cache && parameters.$cache.get(url);
              if (cached !== undefined && parameters.$refresh !== true) {
                  deferred.resolve(cached);
                  return deferred.promise;
              }
              var options = {
                  timeout: parameters.$timeout,
                  method: 'GET',
                  url: url,
                  params: queryParameters,
                  data: body,
                  headers: headers
              };
              if (leanLawAuth.source) {
                  options.headers['x-leanlaw-source'] = leanLawAuth.source;
              }
              queryParameters['timeOffset'] = new Date().getTimezoneOffset();
              if (parameters['createTag']) {
                  options.headers['x-leanlaw-tag'] = parameters['createTag'];
              }
              if (Object.keys(form).length > 0) {
                  options.data = form;
                  options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                  options.transformRequest = leanLawApi.transformRequest;
              }

              auth().then(function(authResult) {
                  if (authResult?.token) {
                      options.headers['Authorization'] = 'Bearer ' + authResult.token;
                  }
                  $http(options).then(function(response) {
                      if (response.status >= 400) {
                          deferred.reject({
                              status: response.status,
                              header: response.headers,
                              config: response.config,
                              body: response.data
                          });
                          return;
                      }
                      return deferred.resolve(response.data);
                      if (parameters.$cache !== undefined) {
                          parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                      }
                  }, function(response) {
                      return deferred.reject({
                          status: response.status,
                          headers: response.headers,
                          config: response.config,
                          body: response.data
                      });
                  });
              }, function(error) {
                  deferred.reject({
                      status: error
                  });
              });

              return deferred.promise;
          };

            /**
             * Get invoices as PDF
             * @method
             * @name leanLawApi#getInvoicesAsPdf
             * @param {string} invoices - Comma-separated list of invoice ids
             * @param {boolean} download - indicates whether to download file or not
             * @param {boolean} zip - indicates whether to paack invoices in zip
             * @param {boolean} includeAttachments - indicates where invoice report should include attachments
             */
             leanLawApi.prototype.getInvoicesAsPdf = function(parameters) {
              if (parameters === undefined) {
                  parameters = {};
              }
              var deferred = $q.defer();

              var domain = this.domain;
              var path = '/invoices/pdf';

              var body;
              var queryParameters = {};
              var headers = {};
              var form = {};

              if (parameters['invoices'] !== undefined) {
                  queryParameters['invoices'] = parameters['invoices'];
              }

              if (parameters['invoices'] === undefined) {
                  deferred.reject(new Error('Missing required  parameter: invoices'));
                  return deferred.promise;
              }

              if (parameters.$queryParameters) {
                  Object.keys(parameters.$queryParameters)
                      .forEach(function(parameterName) {
                          var parameter = parameters.$queryParameters[parameterName];
                          queryParameters[parameterName] = parameter;
                      });
              }

              var url = domain + path;
              var cached = parameters.$cache && parameters.$cache.get(url);
              if (cached !== undefined && parameters.$refresh !== true) {
                  deferred.resolve(cached);
                  return deferred.promise;
              }
              var options = {
                  timeout: parameters.$timeout,
                  method: 'GET',
                  url: url,
                  params: queryParameters,
                  data: body,
                  headers: headers
              };
              if (leanLawAuth.source) {
                  options.headers['x-leanlaw-source'] = leanLawAuth.source;
              }
              queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                  options.headers['x-leanlaw-tag'] = parameters['createTag'];
              }
              if (Object.keys(form).length > 0) {
                  options.data = form;
                  options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                  options.transformRequest = leanLawApi.transformRequest;
              }

              auth().then(function(authResult) {
                  if (authResult?.token) {
                      options.headers['Authorization'] = 'Bearer ' + authResult.token;
                  }
                  $http(options).then(function(response) {
                      if (response.status >= 400) {
                          deferred.reject({
                              status: response.status,
                              header: response.headers,
                              config: response.config,
                              body: response.data
                          });
                          return;
                      }
                      return deferred.resolve(response.data);
                      if (parameters.$cache !== undefined) {
                          parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                      }
                  }, function(response) {
                      return deferred.reject({
                          status: response.status,
                          headers: response.headers,
                          config: response.config,
                          body: response.data
                      });
                  });
              }, function(error) {
                  deferred.reject({
                      status: error
                  });
              });

              return deferred.promise;
          };

            /**
             * Get invoice accounts
             * @method
             * @name leanLawApi#GetInvoiceAccounts
             * @param {string} id - invoice id
             */
                leanLawApi.prototype.getInvoiceAccounts = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}/accounts';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };

           /**
             * Get a client
             * @method
             * @name leanLawApi#getInvoicePaymentAllocation
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getInvoicePaymentAllocation = function(parameters) {
              if (parameters === undefined) {
                  parameters = {};
              }
              var deferred = $q.defer();

              var domain = this.domain;
              var path = '/invoicepayments/{id}/allocation';

              var body;
              var queryParameters = {};
              var headers = {};
              var form = {};

              path = path.replace('{id}', parameters['id']);

              if (parameters['id'] === undefined) {
                  deferred.reject(new Error('Missing required  parameter: id'));
                  return deferred.promise;
              }

              if (parameters.$queryParameters) {
                  Object.keys(parameters.$queryParameters)
                      .forEach(function(parameterName) {
                          var parameter = parameters.$queryParameters[parameterName];
                          queryParameters[parameterName] = parameter;
                      });
              }

              var url = domain + path;
              var cached = parameters.$cache && parameters.$cache.get(url);
              if (cached !== undefined && parameters.$refresh !== true) {
                  deferred.resolve(cached);
                  return deferred.promise;
              }
              var options = {
                  timeout: parameters.$timeout,
                  method: 'GET',
                  url: url,
                  params: queryParameters,
                  data: body,
                  headers: headers
              };
              if (leanLawAuth.source) {
                  options.headers['x-leanlaw-source'] = leanLawAuth.source;
              }
              queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                  options.headers['x-leanlaw-tag'] = parameters['createTag'];
              }
              if (Object.keys(form).length > 0) {
                  options.data = form;
                  options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                  options.transformRequest = leanLawApi.transformRequest;
              }

              auth().then(function(authResult) {
                  if (authResult?.token) {
                      options.headers['Authorization'] = 'Bearer ' + authResult.token;
                  }
                  $http(options).then(function(response) {
                      if (response.status >= 400) {
                          deferred.reject({
                              status: response.status,
                              header: response.headers,
                              config: response.config,
                              body: response.data
                          });
                          return;
                      }
                      return deferred.resolve(response.data);
                      if (parameters.$cache !== undefined) {
                          parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                      }
                  }, function(response) {
                      return deferred.reject({
                          status: response.status,
                          headers: response.headers,
                          config: response.config,
                          body: response.data
                      });
                  });
              }, function(error) {
                  deferred.reject({
                      status: error
                  });
              });

              return deferred.promise;
          };
                     /**
             * Get a client
             * @method
             * @name leanLawApi#getInvoiceAllocation
             * @param {string} id -
             *
             */
                      leanLawApi.prototype.getInvoiceAllocation = function(parameters) {
                        if (parameters === undefined) {
                            parameters = {};
                        }
                        var deferred = $q.defer();

                        var domain = this.domain;
                        var path = '/invoices/{id}/allocation';

                        var body;
                        var queryParameters = {};
                        var headers = {};
                        var form = {};

                        path = path.replace('{id}', parameters['id']);

                        if (parameters['id'] === undefined) {
                            deferred.reject(new Error('Missing required  parameter: id'));
                            return deferred.promise;
                        }

                        if (parameters.$queryParameters) {
                            Object.keys(parameters.$queryParameters)
                                .forEach(function(parameterName) {
                                    var parameter = parameters.$queryParameters[parameterName];
                                    queryParameters[parameterName] = parameter;
                                });
                        }

                        var url = domain + path;
                        var cached = parameters.$cache && parameters.$cache.get(url);
                        if (cached !== undefined && parameters.$refresh !== true) {
                            deferred.resolve(cached);
                            return deferred.promise;
                        }
                        var options = {
                            timeout: parameters.$timeout,
                            method: 'GET',
                            url: url,
                            params: queryParameters,
                            data: body,
                            headers: headers
                        };
                        if (leanLawAuth.source) {
                            options.headers['x-leanlaw-source'] = leanLawAuth.source;
                        }
                        queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                            options.headers['x-leanlaw-tag'] = parameters['createTag'];
                        }
                        if (Object.keys(form).length > 0) {
                            options.data = form;
                            options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                            options.transformRequest = leanLawApi.transformRequest;
                        }

                        auth().then(function(authResult) {
                            if (authResult?.token) {
                                options.headers['Authorization'] = 'Bearer ' + authResult.token;
                            }
                            $http(options).then(function(response) {
                                if (response.status >= 400) {
                                    deferred.reject({
                                        status: response.status,
                                        header: response.headers,
                                        config: response.config,
                                        body: response.data
                                    });
                                    return;
                                }
                                return deferred.resolve(response.data);
                                if (parameters.$cache !== undefined) {
                                    parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                                }
                            }, function(response) {
                                return deferred.reject({
                                    status: response.status,
                                    headers: response.headers,
                                    config: response.config,
                                    body: response.data
                                });
                            });
                        }, function(error) {
                            deferred.reject({
                                status: error
                            });
                        });

                        return deferred.promise;
                    };
           /**
             * Get a client
             * @method
             * @name leanLawApi#getInvoicePaymentAllocation
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getPaymentAllocation = function(parameters) {
              if (parameters === undefined) {
                  parameters = {};
              }
              var deferred = $q.defer();

              var domain = this.domain;
              var path = '/payments/{id}/allocation';

              var body;
              var queryParameters = {};
              var headers = {};
              var form = {};

              path = path.replace('{id}', parameters['id']);

              if (parameters['id'] === undefined) {
                  deferred.reject(new Error('Missing required  parameter: id'));
                  return deferred.promise;
              }

              if (parameters.$queryParameters) {
                  Object.keys(parameters.$queryParameters)
                      .forEach(function(parameterName) {
                          var parameter = parameters.$queryParameters[parameterName];
                          queryParameters[parameterName] = parameter;
                      });
              }

              var url = domain + path;
              var cached = parameters.$cache && parameters.$cache.get(url);
              if (cached !== undefined && parameters.$refresh !== true) {
                  deferred.resolve(cached);
                  return deferred.promise;
              }
              var options = {
                  timeout: parameters.$timeout,
                  method: 'GET',
                  url: url,
                  params: queryParameters,
                  data: body,
                  headers: headers
              };
              if (leanLawAuth.source) {
                  options.headers['x-leanlaw-source'] = leanLawAuth.source;
              }
              queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                  options.headers['x-leanlaw-tag'] = parameters['createTag'];
              }
              if (Object.keys(form).length > 0) {
                  options.data = form;
                  options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                  options.transformRequest = leanLawApi.transformRequest;
              }

              auth().then(function(authResult) {
                  if (authResult?.token) {
                      options.headers['Authorization'] = 'Bearer ' + authResult.token;
                  }
                  $http(options).then(function(response) {
                      if (response.status >= 400) {
                          deferred.reject({
                              status: response.status,
                              header: response.headers,
                              config: response.config,
                              body: response.data
                          });
                          return;
                      }
                      return deferred.resolve(response.data);
                      if (parameters.$cache !== undefined) {
                          parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                      }
                  }, function(response) {
                      return deferred.reject({
                          status: response.status,
                          headers: response.headers,
                          config: response.config,
                          body: response.data
                      });
                  });
              }, function(error) {
                  deferred.reject({
                      status: error
                  });
              });

              return deferred.promise;
          };
            /**
             * Get invoices as LEDES
             * @method
             * @name leanLawApi#getInvoicesAsLedes
             * @param {string} invoices - Comma-separated list of invoice ids
             *
             */
            leanLawApi.prototype.getInvoicesAsLedes = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/ledes';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['invoices'] !== undefined) {
                    queryParameters['invoices'] = parameters['invoices'];
                }

                if (parameters['invoices'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: invoices'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get an invoice
             * @method
             * @name leanLawApi#getInvoice
             * @param {string} id -
             * @param {string} linkedItems -
             *
             */
            leanLawApi.prototype.getInvoice = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['linkedItems'] !== undefined) {
                    queryParameters['linkedItems'] = parameters['linkedItems'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get an invoice
             * @method
             * @name leanLawApi#getInvoice
             * @param {string} id -
             * @param {string} linkedItems -
             *
             */
            leanLawApi.prototype.getInvoiceContent = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}/content';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['linkedItems'] !== undefined) {
                    queryParameters['linkedItems'] = parameters['linkedItems'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update an invoice (activate or archive)
             * @method
             * @name leanLawApi#updateInvoice
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateInvoice = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Delete an invoice, reopening the time entries
             * @method
             * @name leanLawApi#deleteInvoice
             * @param {string} id -
             * @param {boolean} deleteFromAccounting - Determines if invoice is also removed from the accounting system
             *
             */
            leanLawApi.prototype.deleteInvoice = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['deleteFromAccounting'] !== undefined) {
                    queryParameters['deleteFromAccounting'] = parameters['deleteFromAccounting'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'DELETE',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get an invoice as PDF
             * @method
             * @name leanLawApi#getInvoiceAsPdf
             * @param {string} id -
             * @param {boolean} download -
             * @param {boolean} includeAttachments -
             */
            leanLawApi.prototype.getInvoiceAsPdf = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}/pdf';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['download'] !== undefined) {
                    queryParameters['download'] = parameters['download'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get an invoice as LEDES file
             * @method
             * @name leanLawApi#getInvoiceAsLedes
             * @param {string} id -
             * @param {boolean} download -
             *
             */
            leanLawApi.prototype.getInvoiceAsLedes = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}/ledes';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['download'] !== undefined) {
                    queryParameters['download'] = parameters['download'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Submit an invoice to the accounting system
             * @method
             * @name leanLawApi#processInvoice
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.processInvoice = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}/process';

                var body;
              var queryParameters = {};
              if (parameters.bulk) {
                queryParameters.bulk=true;
              }
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Record special adjustment for evergreen retainers
             * @method
             * @name leanLawApi#createInvoiceEvergreenAdjustment
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.createInvoiceEvergreenAdjustment = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}/adjustment';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['clear'] !== undefined) {
                    queryParameters['clear'] = parameters['clear'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Add trust statement to invoice
             * @method
             * @name leanLawApi#addInvoiceTrustStatement
             * @param {string} id -
             *
             */
            leanLawApi.prototype.addInvoiceTrustStatement = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}/trustStatement';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of changes made to invoice
             * @method
             * @name leanLawApi#getInvoiceChanges
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getInvoiceChanges = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}/changes';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get detail for invoice
             * @method
             * @name leanLawApi#getInvoiceDetail
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getInvoiceDetail = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}/detail';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Recall an invoice from the accounting system
             * @method
             * @name leanLawApi#recallInvoice
             * @param {string} id -
             *
             */
            leanLawApi.prototype.recallInvoice = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}/recall';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of payments for invoice
             * @method
             * @name leanLawApi#listInvoicePayments
             * @param {string} id -
             *
             */
            leanLawApi.prototype.listInvoicePayments = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/invoices/{id}/payments';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * List of payments
             * @method
             * @name leanLawApi#listPaymentAllocations
             * @param {string} startDate -
             * @param {string} endDate -
             * @param {string} scope -
             * @param {string} scopeAccount -
             * @param {string} matterId -
             * @param {string} clientId -
             * @param {string} distributionStatus - enum: none, draft, distributed
             * @param {string} distributionId -
             *
             */
            leanLawApi.prototype.listPaymentAllocations = function(parameters) {
              if (parameters === undefined) {
                  parameters = {};
              }
              var deferred = $q.defer();

              var domain = this.domain;
              var path = '/payments/allocations';

              var body;
              var queryParameters = {};
              var headers = {};
              var form = {};

              if (parameters['startDate'] !== undefined) {
                  queryParameters['startDate'] = parameters['startDate'];
              }

              if (parameters['endDate'] !== undefined) {
                  queryParameters['endDate'] = parameters['endDate'];
              }

              if (parameters['scope'] !== undefined) {
                  queryParameters['scope'] = parameters['scope'];
              }

              if (parameters['scopeAccount'] !== undefined) {
                  queryParameters['scopeAccount'] = parameters['scopeAccount'];
              }

              if (parameters['matterId'] !== undefined) {
                  queryParameters['matterId'] = parameters['matterId'];
              }

              if (parameters['clientId'] !== undefined) {
                  queryParameters['clientId'] = parameters['clientId'];
              }

              if (parameters['distributionStatus'] !== undefined) {
                queryParameters['distributionStatus'] = parameters['distributionStatus'];
              }

              if (parameters['distributionId'] !== undefined) {
                queryParameters['distributionId'] = parameters['distributionId'];
              }

              if (parameters.$queryParameters) {
                  Object.keys(parameters.$queryParameters)
                      .forEach(function(parameterName) {
                          var parameter = parameters.$queryParameters[parameterName];
                          queryParameters[parameterName] = parameter;
                      });
              }

              var url = domain + path;
              var cached = parameters.$cache && parameters.$cache.get(url);
              if (cached !== undefined && parameters.$refresh !== true) {
                  deferred.resolve(cached);
                  return deferred.promise;
              }
              var options = {
                  timeout: parameters.$timeout,
                  method: 'GET',
                  url: url,
                  params: queryParameters,
                  data: body,
                  headers: headers
              };
              if (leanLawAuth.source) {
                  options.headers['x-leanlaw-source'] = leanLawAuth.source;
              }
              queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                  options.headers['x-leanlaw-tag'] = parameters['createTag'];
              }
              if (Object.keys(form).length > 0) {
                  options.data = form;
                  options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                  options.transformRequest = leanLawApi.transformRequest;
              }

              auth().then(function(authResult) {
                  if (authResult?.token) {
                      options.headers['Authorization'] = 'Bearer ' + authResult.token;
                  }
                  $http(options).then(function(response) {
                      if (response.status >= 400) {
                          deferred.reject({
                              status: response.status,
                              header: response.headers,
                              config: response.config,
                              body: response.data
                          });
                          return;
                      }
                      return deferred.resolve(response.data);
                      if (parameters.$cache !== undefined) {
                          parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                      }
                  }, function(response) {
                      return deferred.reject({
                          status: response.status,
                          headers: response.headers,
                          config: response.config,
                          body: response.data
                      });
                  });
              }, function(error) {
                  deferred.reject({
                      status: error
                  });
              });

              return deferred.promise;
          };
            /**
             * List of payments
             * @method
             * @name leanLawApi#listPayments
             * @param {string} startDate -
             * @param {string} endDate -
             * @param {string} scope -
             * @param {string} scopeAccount -
             * @param {string} matterId -
             * @param {string} clientId -
             * @param {string} distributionStatus - enum: none, draft, distributed
             * @param {string} distributionId -
             */
            leanLawApi.prototype.listPayments = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/payments';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['startDate'] !== undefined) {
                    queryParameters['startDate'] = parameters['startDate'];
                }

                if (parameters['endDate'] !== undefined) {
                    queryParameters['endDate'] = parameters['endDate'];
                }

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters['matterId'] !== undefined) {
                    queryParameters['matterId'] = parameters['matterId'];
                }

                if (parameters['clientId'] !== undefined) {
                    queryParameters['clientId'] = parameters['clientId'];
                }

                if (parameters['distributionStatus'] !== undefined) {
                    queryParameters['distributionStatus'] = parameters['distributionStatus'];
                }

                if (parameters['distributionId'] !== undefined) {
                    queryParameters['distributionId'] = parameters['distributionId'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update payment distribution
             * @method
             * @name leanLawApi#updatePaymentDistribution
             * @param {} body -
             *
             */
             leanLawApi.prototype.updatePaymentDistribution = function(parameters) {
              if (parameters === undefined) {
                  parameters = {};
              }
              var deferred = $q.defer();

              var domain = this.domain;
              var path = '/distributions/{id}';

              var body;
              var queryParameters = {};
              var headers = {};
              var form = {};

              path = path.replace('{id}', parameters['id']);

              if (parameters['id'] === undefined) {
                  deferred.reject(new Error('Missing required  parameter: id'));
                  return deferred.promise;
              }

              if (parameters['body'] !== undefined) {
                  body = parameters['body'];
              }

              if (parameters.$queryParameters) {
                  Object.keys(parameters.$queryParameters)
                      .forEach(function(parameterName) {
                          var parameter = parameters.$queryParameters[parameterName];
                          queryParameters[parameterName] = parameter;
                      });
              }

              var url = domain + path;
              var options = {
                  timeout: parameters.$timeout,
                  method: 'PUT',
                  url: url,
                  params: queryParameters,
                  data: body,
                  headers: headers
              };
              if (leanLawAuth.source) {
                  options.headers['x-leanlaw-source'] = leanLawAuth.source;
              }
              queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                  options.headers['x-leanlaw-tag'] = parameters['createTag'];
              }
              if (Object.keys(form).length > 0) {
                  options.data = form;
                  options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                  options.transformRequest = leanLawApi.transformRequest;
              }

              auth().then(function(authResult) {
                  if (authResult?.token) {
                      options.headers['Authorization'] = 'Bearer ' + authResult.token;
                  }
                  $http(options).then(function(response) {
                      if (response.status >= 400) {
                          deferred.reject({
                              status: response.status,
                              header: response.headers,
                              config: response.config,
                              body: response.data
                          });
                          return;
                      }
                      return deferred.resolve(response.data);
                      if (parameters.$cache !== undefined) {
                          parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                      }
                  }, function(response) {
                      return deferred.reject({
                          status: response.status,
                          headers: response.headers,
                          config: response.config,
                          body: response.data
                      });
                  });
              }, function(error) {
                  deferred.reject({
                      status: error
                  });
              });

              return deferred.promise;
          };
          /**
          /**
          * Create payment distribution
          * @method
          * @name leanLawApi#createPaymentDistribution
          * @param {} body -
          *
          */
         leanLawApi.prototype.createPaymentDistribution = function(parameters) {
             if (parameters === undefined) {
                 parameters = {};
             }
             var deferred = $q.defer();

             var domain = this.domain;
             var path = '/distributions';

             var body;
             var queryParameters = {};
             var headers = {};
             var form = {};

             if (parameters['body'] !== undefined) {
                 body = parameters['body'];
             }

             if (parameters.$queryParameters) {
                 Object.keys(parameters.$queryParameters)
                     .forEach(function(parameterName) {
                         var parameter = parameters.$queryParameters[parameterName];
                         queryParameters[parameterName] = parameter;
                     });
             }

             var url = domain + path;
             var options = {
                 timeout: parameters.$timeout,
                 method: 'POST',
                 url: url,
                 params: queryParameters,
                 data: body,
                 headers: headers
             };
             if (leanLawAuth.source) {
                 options.headers['x-leanlaw-source'] = leanLawAuth.source;
             }
             queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                 options.headers['x-leanlaw-tag'] = parameters['createTag'];
             }
             if (Object.keys(form).length > 0) {
                 options.data = form;
                 options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                 options.transformRequest = leanLawApi.transformRequest;
             }

             auth().then(function(authResult) {
                 if (authResult?.token) {
                     options.headers['Authorization'] = 'Bearer ' + authResult.token;
                 }
                 $http(options).then(function(response) {
                     if (response.status >= 400) {
                         deferred.reject({
                             status: response.status,
                             header: response.headers,
                             config: response.config,
                             body: response.data
                         });
                         return;
                     }
                     return deferred.resolve(response.data);
                     if (parameters.$cache !== undefined) {
                         parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                     }
                 }, function(response) {
                     return deferred.reject({
                         status: response.status,
                         headers: response.headers,
                         config: response.config,
                         body: response.data
                     });
                 });
             }, function(error) {
                 deferred.reject({
                     status: error
                 });
             });

             return deferred.promise;
         };
            leanLawApi.prototype.listPaymentDistributions = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/distributions';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of charges
             * @method
             * @name leanLawApi#listCharges
             * @param {string} startDate -
             * @param {string} endDate -
             * @param {boolean} excludeNoDate -
             * @param {string} billed -
             * @param {string} customFlag -
             * @param {string} scope -
             * @param {string} scopeAccount -
             * @param {string} matterId -
             * @param {string} clientId -
             * @param {string} account -
             *
             */
            leanLawApi.prototype.listCharges = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/charges';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['startDate'] !== undefined) {
                    queryParameters['startDate'] = parameters['startDate'];
                }

                if (parameters['endDate'] !== undefined) {
                    queryParameters['endDate'] = parameters['endDate'];
                }

                if (parameters['billedState'] !== undefined) {
                    queryParameters['billedState'] = parameters['billedState'];
                }

                if (parameters['excludeNoDate'] !== undefined) {
                    queryParameters['excludeNoDate'] = parameters['excludeNoDate'];
                }

                if (parameters['billed'] !== undefined) {
                    queryParameters['billed'] = parameters['billed'];
                }

                if (parameters['acceptsTime'] !== undefined) {
                    queryParameters['acceptsTime'] = parameters['acceptsTime'];
                }

                if (parameters['chargeCompleted'] !== undefined) {
                    queryParameters['chargeCompleted'] = parameters['chargeCompleted'];
                }

                if (parameters['customFlag'] !== undefined) {
                    queryParameters['customFlag'] = parameters['customFlag'];
                }

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters['matterId'] !== undefined) {
                    queryParameters['matterId'] = parameters['matterId'];
                }

                if (parameters['clientId'] !== undefined) {
                    queryParameters['clientId'] = parameters['clientId'];
                }

                if (parameters['account'] !== undefined) {
                    queryParameters['account'] = parameters['account'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }


                if (parameters['mattersIds'] !== undefined) {
                    const matterIdsParam = parameters.mattersIds.map(id => `matterIds=${id}`).join('&');
                    path = path + (path.includes('?') ? '&' : '?') + matterIdsParam;
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create charge
             * @method
             * @name leanLawApi#createCharge
             * @param {} body -
             *
             */
            leanLawApi.prototype.createCharge = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/charges';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of standard charges
             * @method
             * @name leanLawApi#listStandardCharges
             *
             */
            leanLawApi.prototype.listStandardCharges = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/charges/standard';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create standard charge
             * @method
             * @name leanLawApi#createStandardCharge
             * @param {} body -
             *
             */
            leanLawApi.prototype.createStandardCharge = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/charges/standard';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get charge
             * @method
             * @name leanLawApi#getCharge
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getCharge = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/charges/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Delete charge
             * @method
             * @name leanLawApi#deleteCharge
             * @param {string} id -
             *
             */
            leanLawApi.prototype.deleteCharge = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/charges/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'DELETE',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update charge
             * @method
             * @name leanLawApi#updateCharge
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateCharge = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/charges/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of expenses for the firm
             * @method
             * @name leanLawApi#listExpenses
             * @param {integer} offset -
             * @param {integer} limit -
             * @param {string} orderby -
             * @param {string} order -
             * @param {string} startDate -
             * @param {string} endDate -
             * @param {string} billed -
             * @param {string} billable -
             * @param {string} customFlag -
             * @param {string} account -
             * @param {boolean} hidden -
             * @param {string} scope -
             * @param {string} scopeAccount -
             * @param {string} clientId -
             * @param {string} matterId -
             * @param {string} status -
             * @param {string} assigned -
             *
             */
            leanLawApi.prototype.listExpenses = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/expenses';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['offset'] !== undefined) {
                    queryParameters['offset'] = parameters['offset'];
                }

                if (parameters['limit'] !== undefined) {
                    queryParameters['limit'] = parameters['limit'];
                }

                if (parameters['orderby'] !== undefined) {
                    queryParameters['orderby'] = parameters['orderby'];
                }

                if (parameters['order'] !== undefined) {
                    queryParameters['order'] = parameters['order'];
                }

                if (parameters['billedState'] !== undefined) {
                    queryParameters['billedState'] = parameters['billedState'];
                }

                if (parameters['startDate'] !== undefined) {
                    queryParameters['startDate'] = parameters['startDate'];
                }

                if (parameters['endDate'] !== undefined) {
                    queryParameters['endDate'] = parameters['endDate'];
                }

                if (parameters['billed'] !== undefined) {
                    queryParameters['billed'] = parameters['billed'];
                }

                if (parameters['chargeCompleted'] !== undefined) {
                    queryParameters['chargeCompleted'] = parameters['chargeCompleted'];
                }

                if (parameters['billable'] !== undefined) {
                    queryParameters['billable'] = parameters['billable'];
                }

                if (parameters['customFlag'] !== undefined) {
                    queryParameters['customFlag'] = parameters['customFlag'];
                }

                if (parameters['account'] !== undefined) {
                    queryParameters['account'] = parameters['account'];
                }

                if (parameters['hidden'] !== undefined) {
                    queryParameters['hidden'] = parameters['hidden'];
                }

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters['clientId'] !== undefined) {
                    queryParameters['clientId'] = parameters['clientId'];
                }

                if (parameters['matterId'] !== undefined) {
                    queryParameters['matterId'] = parameters['matterId'];
                }

                if (parameters['status'] !== undefined) {
                    queryParameters['status'] = parameters['status'];
                }

                if (parameters['assigned'] !== undefined) {
                    queryParameters['assigned'] = parameters['assigned'];
                }

                if (parameters['billingType'] !== undefined) {
                    queryParameters['billingType'] = parameters['billingType'];
                }

                if (parameters['expenseType'] !== undefined) {
                    queryParameters['expenseType'] = parameters['expenseType'];
                }

                if (parameters['attachments'] !== undefined) {
                    queryParameters['attachments'] = parameters['attachments'];
                }

                if (parameters['customFlag'] !== undefined) {
                    queryParameters['customFlag'] = parameters['customFlag'];
                }


                if (parameters['expensePaid'] !== undefined) {
                    queryParameters['expensePaid'] = parameters['expensePaid'];
                }


                if (parameters['search'] !== undefined) {
                    queryParameters['search'] = parameters['search'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get expense
             * @method
             * @name leanLawApi#getExpense
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getExpense = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/expenses/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update expense
             * @method
             * @name leanLawApi#updateExpense
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateExpense = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/expenses/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Delete expense
             * @method
             * @name leanLawApi#deleteExpense
             * @param {string} id -
             *
             */
            leanLawApi.prototype.deleteExpense = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/expenses/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'DELETE',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get planner entries
             * @method
             * @name leanLawApi#listEntries
             * @param {integer} offset -
             * @param {integer} limit -
             * @param {string} orderby -
             * @param {string} order -
             * @param {string} startDate -
             * @param {string} endDate -
             * @param {integer} timeOffset -
             * @param {string} billable -
             * @param {string} billed - Return entries that were billed or not billed or both. Default is not billed (false)
             * @param {string} customFlag -
             * @param {string} account - Account id or 'me' to show logged in users entries
             * @param {string} clientId -
             * @param {string} matterId -
             * @param {string} include - Specifify what is included in response. Valid option is 'summary' which means that only summary is included in the response.
             * @param {string} scope -
             * @param {string} scopeAccount -
             * @param {string} status -
             * @param {string} search -
             *
             */
            leanLawApi.prototype.listEntries = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/entries';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['offset'] !== undefined) {
                    queryParameters['offset'] = parameters['offset'];
                }

                if (parameters['limit'] !== undefined) {
                    queryParameters['limit'] = parameters['limit'];
                }

                if (parameters['orderby'] !== undefined) {
                    queryParameters['orderby'] = parameters['orderby'];
                }

                if (parameters['order'] !== undefined) {
                    queryParameters['order'] = parameters['order'];
                }

                if (parameters['startDate'] !== undefined) {
                    queryParameters['startDate'] = parameters['startDate'];
                }

                if (parameters['endDate'] !== undefined) {
                    queryParameters['endDate'] = parameters['endDate'];
                }

                if (parameters['billedState'] !== undefined) {
                    queryParameters['billedState'] = parameters['billedState'];
                }

                if (queryParameters['timeOffset'] !== undefined) {
                    queryqueryParameters['timeOffset'] = queryParameters['timeOffset'];
                }

                if (parameters['billable'] !== undefined) {
                    queryParameters['billable'] = parameters['billable'];
                }

                if (parameters['billed'] !== undefined) {
                    queryParameters['billed'] = parameters['billed'];
                }

                if (parameters['activity'] !== undefined) {
                    queryParameters['activity'] = parameters['activity'];
                }

                if (parameters['task'] !== undefined) {
                    queryParameters['task'] = parameters['task'];
                }

                if (parameters['customFlag'] !== undefined) {
                    queryParameters['customFlag'] = parameters['customFlag'];
                }

                if (parameters['account'] !== undefined) {
                    queryParameters['account'] = parameters['account'];
                }

                if (parameters['clientId'] !== undefined) {
                    queryParameters['clientId'] = parameters['clientId'];
                }

                if (parameters['matterId'] !== undefined) {
                    queryParameters['matterId'] = parameters['matterId'];
                }

                if (parameters['include'] !== undefined) {
                    queryParameters['include'] = parameters['include'];
                }

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters['status'] !== undefined) {
                    queryParameters['status'] = parameters['status'];
                }

                if (parameters['search'] !== undefined) {
                    queryParameters['search'] = parameters['search'];
                }

                if (parameters['chargeId'] !== undefined) {
                    queryParameters['chargeId'] = parameters['chargeId'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create planner entry
             * @method
             * @name leanLawApi#createEntry
             * @param {} body -
             *
             */
            leanLawApi.prototype.createEntry = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/entries';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Mark entries as billed
             * @method
             * @name leanLawApi#markEntries
             * @param {} body -
             *
             */
            leanLawApi.prototype.markEntries = function(parameters) {
              if (parameters === undefined) {
                  parameters = {};
              }
              var deferred = $q.defer();

              var domain = this.domain;
              var path = '/entries/mark';

              var body;
              var queryParameters = {};
              var headers = {};
              var form = {};

              if (parameters['body'] !== undefined) {
                  body = parameters['body'];
              }

              if (parameters.$queryParameters) {
                  Object.keys(parameters.$queryParameters)
                      .forEach(function(parameterName) {
                          var parameter = parameters.$queryParameters[parameterName];
                          queryParameters[parameterName] = parameter;
                      });
              }

              var url = domain + path;
              var options = {
                  timeout: parameters.$timeout,
                  method: 'POST',
                  url: url,
                  params: queryParameters,
                  data: body,
                  headers: headers
              };
              if (leanLawAuth.source) {
                  options.headers['x-leanlaw-source'] = leanLawAuth.source;
              }
              queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                  options.headers['x-leanlaw-tag'] = parameters['createTag'];
              }
              if (Object.keys(form).length > 0) {
                  options.data = form;
                  options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                  options.transformRequest = leanLawApi.transformRequest;
              }

              auth().then(function(authResult) {
                  if (authResult?.token) {
                      options.headers['Authorization'] = 'Bearer ' + authResult.token;
                  }
                  $http(options).then(function(response) {
                      if (response.status >= 400) {
                          deferred.reject({
                              status: response.status,
                              header: response.headers,
                              config: response.config,
                              body: response.data
                          });
                          return;
                      }
                      return deferred.resolve(response.data);
                      if (parameters.$cache !== undefined) {
                          parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                      }
                  }, function(response) {
                      return deferred.reject({
                          status: response.status,
                          headers: response.headers,
                          config: response.config,
                          body: response.data
                      });
                  });
              }, function(error) {
                  deferred.reject({
                      status: error
                  });
              });

              return deferred.promise;
          };

            leanLawApi.prototype.updateEntries = function(parameters) {
              if (parameters === undefined) {
                  parameters = {};
              }
              var deferred = $q.defer();

              var domain = this.domain;
              var path = '/invoices/update-invoice';

              var body;
              var queryParameters = {};
              var headers = {};
              var form = {};

              if (parameters['body'] !== undefined) {
                  body = parameters['body'];
              }

              if (parameters.$queryParameters) {
                  Object.keys(parameters.$queryParameters)
                      .forEach(function(parameterName) {
                          var parameter = parameters.$queryParameters[parameterName];
                          queryParameters[parameterName] = parameter;
                      });
              }

              var url = domain + path;
              var options = {
                  timeout: parameters.$timeout,
                  method: 'PUT',
                  url: url,
                  params: queryParameters,
                  data: body,
                  headers: headers
              };
              if (leanLawAuth.source) {
                  options.headers['x-leanlaw-source'] = leanLawAuth.source;
              }
              queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                  options.headers['x-leanlaw-tag'] = parameters['createTag'];
              }
              if (Object.keys(form).length > 0) {
                  options.data = form;
                  options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                  options.transformRequest = leanLawApi.transformRequest;
              }

              auth().then(function(authResult) {
                  if (authResult?.token) {
                      options.headers['Authorization'] = 'Bearer ' + authResult.token;
                  }
                  $http(options).then(function(response) {
                      if (response.status >= 400) {
                          deferred.reject({
                              status: response.status,
                              header: response.headers,
                              config: response.config,
                              body: response.data
                          });
                          return;
                      }
                      return deferred.resolve(response.data);
                      if (parameters.$cache !== undefined) {
                          parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                      }
                  }, function(response) {
                      return deferred.reject({
                          status: response.status,
                          headers: response.headers,
                          config: response.config,
                          body: response.data
                      });
                  });
              }, function(error) {
                  deferred.reject({
                      status: error
                  });
              });

              return deferred.promise;
          };
            /**
             * Get planner entry
             * @method
             * @name leanLawApi#getEntry
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getEntry = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/entries/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update planner entry
             * @method
             * @name leanLawApi#updateEntry
             * @param {string} id -
             * @param {} body -
             * @param {boolean} force -
             *
             */
            leanLawApi.prototype.updateEntry = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/entries/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['force'] !== undefined) {
                    queryParameters['force'] = parameters['force'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Delete a time entry
             * @method
             * @name leanLawApi#deleteEntry
             * @param {string} id -
             *
             */
            leanLawApi.prototype.deleteEntry = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/entries/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'DELETE',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get tasks
             * @method
             * @name leanLawApi#listTasks
             *
             */
            leanLawApi.prototype.listTasks = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/tasks';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create task
             * @method
             * @name leanLawApi#createTask
             * @param {} body -
             *
             */
            leanLawApi.prototype.createTask = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/tasks';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update task
             * @method
             * @name leanLawApi#updateTask
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateTask = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/tasks/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Delete task
             * @method
             * @name leanLawApi#deleteTask
             * @param {string} id -
             *
             */
            leanLawApi.prototype.deleteTask = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/tasks/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'DELETE',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create a log entry for debugging purposes
             * @method
             * @name leanLawApi#createLog
             * @param {} body -
             *
             */
            leanLawApi.prototype.createLog = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/logs';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };

            /**
             * Get status of accounting integration
             * @method
             * @name leanLawApi#getAccounting
             *
             */
            leanLawApi.prototype.getAccounting = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get accounting defaults and settings
             * @method
             * @name leanLawApi#getAccountingSettings
             *
             */
            leanLawApi.prototype.getAccountingSettings = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/settings';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update settings
             * @method
             * @name leanLawApi#updateAccountingSettings
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateAccountingSettings = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/settings';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Remove all accounting references from LL
             * @method
             * @name leanLawApi#purgeAccounting
             *
             */
            leanLawApi.prototype.purgeAccounting = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/purge';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of valid payment terms
             * @method
             * @name leanLawApi#listAccountingTerms
             *
             */
            leanLawApi.prototype.listAccountingTerms = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/terms';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of valid payment methods
             * @method
             * @name leanLawApi#listAccountingMethods
             *
             */
            leanLawApi.prototype.listAccountingMethods = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/methods';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#listAccountingPayments
             * @param {string} clientId -
             * @param {string} matterId -
             * @param {string} startDate -
             * @param {string} endDate -
             * @param {string} scope -
             * @param {string} scopeAccount - Scope is from the perspective of this account id (default is logged in user's account)
             *
             */
            leanLawApi.prototype.listAccountingPayments = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/payments';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['clientId'] !== undefined) {
                    queryParameters['clientId'] = parameters['clientId'];
                }

                if (parameters['matterId'] !== undefined) {
                    queryParameters['matterId'] = parameters['matterId'];
                }

                if (parameters['startDate'] !== undefined) {
                    queryParameters['startDate'] = parameters['startDate'];
                }

                if (parameters['endDate'] !== undefined) {
                    queryParameters['endDate'] = parameters['endDate'];
                }

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Orchestrate payment of invoice through trust account connected with this client or matter
             * @method
             * @name leanLawApi#createAccountingPayment
             * @param {} body -
             *
             */
            leanLawApi.prototype.createAccountingPayment = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/payments';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#listAccountingTrust
             * @param {string} scope -
             * @param {string} scopeAccount -
             * @param {string} status -
             * @param {string} matterTag -
             *
             */
            leanLawApi.prototype.listAccountingTrust = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/trusts';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters['status'] !== undefined) {
                    queryParameters['status'] = parameters['status'];
                }

                if (parameters['matterTag'] !== undefined) {
                    queryParameters['matterTag'] = parameters['matterTag'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#getAccountingTrust
             * @param {string} scope -
             * @param {string} scopeAccount -
             *
             */
            leanLawApi.prototype.getAccountingTrust = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/trust';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of accounting clients with balances (in Quickbooks this returns a list of top-level customers)
             * @method
             * @name leanLawApi#listAccountingClients
             * @param {string} scope -
             * @param {string} scopeAccount -
             *
             */
            leanLawApi.prototype.listAccountingClients = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/clients';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get accounting client
             * @method
             * @name leanLawApi#getAccountingClient
             * @param {string} id -
             *
             */
            leanLawApi.prototype.getAccountingClient = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/clients/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#updateAccountingClient
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateAccountingClient = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/clients/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             *
             * @method
             * @name leanLawApi#deleteAccountingClient
             * @param {string} id -
             *
             */
            leanLawApi.prototype.deleteAccountingClient = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/clients/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'DELETE',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create a new service
             * @method
             * @name leanLawApi#createAccountingService
             * @param {} body -
             *
             */
            leanLawApi.prototype.createAccountingService = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/services';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of accounting services (in Quickbooks this returns a list of Service/Product account ids)
             * @method
             * @name leanLawApi#listAccountingServices
             *
             */
            leanLawApi.prototype.listAccountingServices = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/services';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create a new class
             * @method
             * @name leanLawApi#createAccountingClass
             * @param {} body -
             *
             */
            leanLawApi.prototype.createAccountingClass = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/classes';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of classes
             * @method
             * @name leanLawApi#listAccountingClasses
             *
             */
            leanLawApi.prototype.listAccountingClasses = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/classes';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of classes
             * @method
             * @name leanLawApi#listTags
             *
             */
            leanLawApi.prototype.listTags = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/tags';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create a new tags
             * @method
             * @name leanLawApi#createTag
             * @param {} body -
             *
             */
            leanLawApi.prototype.createTag = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/tags';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create a new tag
             * @method
             * @name leanLawApi#createMatterTag
             * @param {} body -
             *
             */
            leanLawApi.prototype.createMatterTag = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/mattertags';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Delete matter tag
             * @method
             * @name leanLawApi#deleteMatterTag
             * @param {string} id -
             * @param {string} reassign -
             *
             */
            leanLawApi.prototype.deleteMatterTag = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/mattertags/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['reassign'] !== undefined) {
                    queryParameters['reassign'] = parameters['reassign'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'DELETE',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Update a tag
             * @method
             * @name leanLawApi#updateMatterTag
             * @param {string} id -
             * @param {} body -
             *
             */
            leanLawApi.prototype.updateMatterTag = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/mattertags/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'PUT',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * List taxcodes
             * @method
             * @name leanLawApi#listTaxcodes
             *
             */
            leanLawApi.prototype.listTaxcodes = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/taxcodes';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Create a Quickbooks account
             * @method
             * @name leanLawApi#createAccountingAccount
             * @param {} body -
             *
             */
            leanLawApi.prototype.createAccountingAccount = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/accounts';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['body'] !== undefined) {
                    body = parameters['body'];
                }

                if (parameters['body'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: body'));
                    return deferred.promise;
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var options = {
                    timeout: parameters.$timeout,
                    method: 'POST',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get list of accounts
             * @method
             * @name leanLawApi#listAccountingAccounts
             * @param {string} type -
             *
             */
            leanLawApi.prototype.listAccountingAccounts = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/accounts';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['type'] !== undefined) {
                    queryParameters['type'] = parameters['type'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get detail for account, including balances and transactions
             * @method
             * @name leanLawApi#getAccountingAccount
             * @param {string} id -
             * @param {boolean} transactions -
             *
             */
            leanLawApi.prototype.getAccountingAccount = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/accounting/accounts/{id}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                path = path.replace('{id}', parameters['id']);

                if (parameters['id'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: id'));
                    return deferred.promise;
                }

                if (parameters['transactions'] !== undefined) {
                    queryParameters['transactions'] = parameters['transactions'];
                }

                if (parameters['clients'] !== undefined) {
                    queryParameters['clients'] = parameters['clients'];
                }

                if (parameters['startDate'] !== undefined) {
                    queryParameters['startDate'] = parameters['startDate'];
                }

                if (parameters['endDate'] !== undefined) {
                    queryParameters['endDate'] = parameters['endDate'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
            /**
             * Get report. Primary dimension is required, secondary is optional.
             * @method
             * @name leanLawApi#getReport
             * @param {string} primary -
             * @param {string} secondary -
             * @param {string} clientId -
             * @param {string} matterId -
             * @param {string} startDate -
             * @param {string} endDate -
             * @param {boolean} excludeNoDate -
             * @param {boolean} expenseRange -
             * @param {string} expenseStartDate -
             * @param {string} expenseEndDate -
             * @param {string} billed -
             * @param {string} billingType -
             * @param {string} account - Only include entries for this account
             * @param {string} scope -
             * @param {string} scopeAccount - Scope is from the perspective of this account id (default is logged in user's account)
             * @param {string} data -
             * @param {string} detail -
             * @param {string} period -
             * @param {boolean} zeros - Should we include zero records
             * @param {string} zerosKey -
             * @param {integer} offset -
             * @param {integer} timeOffset -
             * @param {string} accountFilter -
             * @param {string} status -
             * @param {string} matterTag -
             * @param {boolean} expenseInterest -
             * @param {boolean} unallocated -
             * @param {string} customFlag -
             * @param {string} distributionStatus - enum: none, draft, distributed
             * @param {string} distributionId -
             *
             */
            leanLawApi.prototype.getReport = function(parameters) {
                if (parameters === undefined) {
                    parameters = {};
                }
                var deferred = $q.defer();

                var domain = this.domain;
                var path = '/reports/{primary}';

                var body;
                var queryParameters = {};
                var headers = {};
                var form = {};

                if (parameters['reportType']) {
                    path = '/reports/{primary}/{reportType}';
                    path = path.replace('{reportType}', parameters['reportType']);
                }

                path = path.replace('{primary}', parameters['primary']);

                // copy all parameters that starts with the string "customField" to the queryParameters
                for (var key in parameters) {
                    if (key.toLowerCase().indexOf('customfield') > -1) {
                        queryParameters[key] = parameters[key];
                    }
                }

                if (parameters['primary'] === undefined) {
                    deferred.reject(new Error('Missing required  parameter: primary'));
                    return deferred.promise;
                }

                if (parameters['secondary'] !== undefined) {
                    queryParameters['secondary'] = parameters['secondary'];
                }

                if (parameters['clientId'] !== undefined) {
                    queryParameters['clientId'] = parameters['clientId'];
                }

                if (parameters['matterId'] !== undefined) {
                    queryParameters['matterId'] = parameters['matterId'];
                }

                if (parameters['chargeCompleted'] !== undefined) {
                    queryParameters['chargeCompleted'] = parameters['chargeCompleted'];
                }

                if (parameters['startDate'] !== undefined) {
                    queryParameters['startDate'] = parameters['startDate'];
                }

                if (parameters['endDate'] !== undefined) {
                    queryParameters['endDate'] = parameters['endDate'];
                }

                if (parameters['billedState'] !== undefined) {
                    queryParameters['billedState'] = parameters['billedState'];
                }

                if (parameters['excludeNoDate'] !== undefined) {
                    queryParameters['excludeNoDate'] = parameters['excludeNoDate'];
                }

                if (parameters['expenseRange'] !== undefined) {
                    queryParameters['expenseRange'] = parameters['expenseRange'];
                }

                if (parameters['expenseStartDate'] !== undefined) {
                    queryParameters['expenseStartDate'] = parameters['expenseStartDate'];
                }

                if (parameters['expenseEndDate'] !== undefined) {
                    queryParameters['expenseEndDate'] = parameters['expenseEndDate'];
                }

                if (parameters['billed'] !== undefined) {
                    queryParameters['billed'] = parameters['billed'];
                }

                if (parameters['distributionStatus'] !== undefined) {
                    queryParameters['distributionStatus'] = parameters['distributionStatus'];
                }

                if (parameters['distributionId'] !== undefined) {
                    queryParameters['distributionId'] = parameters['distributionId'];
                }

                if (parameters['billingType'] !== undefined) {
                    queryParameters['billingType'] = parameters['billingType'];
                }

                if (parameters['account'] !== undefined) {
                    queryParameters['account'] = parameters['account'];
                }

                if (parameters['scope'] !== undefined) {
                    queryParameters['scope'] = parameters['scope'];
                }

                if (parameters['scopeAccount'] !== undefined) {
                    queryParameters['scopeAccount'] = parameters['scopeAccount'];
                }

                if (parameters['data'] !== undefined) {
                    queryParameters['data'] = parameters['data'];
                }

                if (parameters['detail'] !== undefined) {
                    queryParameters['detail'] = parameters['detail'];
                }

                if (parameters['period'] !== undefined) {
                    queryParameters['period'] = parameters['period'];
                }

                if (parameters['zeros'] !== undefined) {
                    queryParameters['zeros'] = parameters['zeros'];
                }

                if (parameters['zerosKey'] !== undefined) {
                    queryParameters['zerosKey'] = parameters['zerosKey'];
                }

                if (parameters['offset'] !== undefined) {
                    queryParameters['offset'] = parameters['offset'];
                }

                if (queryParameters['timeOffset'] !== undefined) {
                    queryqueryParameters['timeOffset'] = queryParameters['timeOffset'];
                }

                if (parameters['accountFilter'] !== undefined) {
                    queryParameters['accountFilter'] = parameters['accountFilter'];
                }

                if (parameters['status'] !== undefined) {
                    queryParameters['status'] = parameters['status'];
                }

                if (parameters['matterTag'] !== undefined) {
                    queryParameters['matterTag'] = parameters['matterTag'];
                }

                if (parameters['expenseInterest'] !== undefined) {
                    queryParameters['expenseInterest'] = parameters['expenseInterest'];
                }

                if (parameters['unallocated'] !== undefined) {
                    queryParameters['unallocated'] = parameters['unallocated'];
                }

                if (parameters['customFlag'] !== undefined) {
                    queryParameters['customFlag'] = parameters['customFlag'];
                }

                if (parameters['distributionStatus'] !== undefined) {
                    queryParameters['distributionStatus'] = parameters['distributionStatus'];
                }

                if (parameters['distributionId'] !== undefined) {
                    queryParameters['distributionId'] = parameters['distributionId'];
                }

                if (parameters['source'] !== undefined) {
                    queryParameters['source'] = parameters['source'];
                }

                if (parameters.$queryParameters) {
                    Object.keys(parameters.$queryParameters)
                        .forEach(function(parameterName) {
                            var parameter = parameters.$queryParameters[parameterName];
                            queryParameters[parameterName] = parameter;
                        });
                }

                var url = domain + path;
                var cached = parameters.$cache && parameters.$cache.get(url);
                if (cached !== undefined && parameters.$refresh !== true) {
                    deferred.resolve(cached);
                    return deferred.promise;
                }
                var options = {
                    timeout: parameters.$timeout,
                    method: 'GET',
                    url: url,
                    params: queryParameters,
                    data: body,
                    headers: headers
                };
                options.headers['x-leanlaw-version'] = 'v1';
if (leanLawAuth.source) {
                    options.headers['x-leanlaw-source'] = leanLawAuth.source;
                }
                queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
                    options.headers['x-leanlaw-tag'] = parameters['createTag'];
                }
                if (Object.keys(form).length > 0) {
                    options.data = form;
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    options.transformRequest = leanLawApi.transformRequest;
                }

                auth().then(function(authResult) {
                    if (authResult?.token) {
                        options.headers['Authorization'] = 'Bearer ' + authResult.token;
                    }
                    $http(options).then(function(response) {
                        if (response.status >= 400) {
                            deferred.reject({
                                status: response.status,
                                header: response.headers,
                                config: response.config,
                                body: response.data
                            });
                            return;
                        }
                        return deferred.resolve(response.data);
                        if (parameters.$cache !== undefined) {
                            parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                        }
                    }, function(response) {
                        return deferred.reject({
                            status: response.status,
                            headers: response.headers,
                            config: response.config,
                            body: response.data
                        });
                    });
                }, function(error) {
                    deferred.reject({
                        status: error
                    });
                });

                return deferred.promise;
            };
          /**
           * Get external time events
           * @method
           * @name leanLawApi#listExternalTimeEvents
           */
          leanLawApi.prototype.listExternalTimeEvents = function(parameters) {
            if (parameters === undefined) {
              parameters = {};
            }
            var deferred = $q.defer();

            var domain = this.domain;
            var path = '/externalTimeEvents';

            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};

            if (parameters.$queryParameters) {
              Object.keys(parameters.$queryParameters)
                .forEach(function(parameterName) {
                  var parameter = parameters.$queryParameters[parameterName];
                  queryParameters[parameterName] = parameter;
                });
            }

            var url = domain + path;
            var cached = parameters.$cache && parameters.$cache.get(url);
            if (cached !== undefined && parameters.$refresh !== true) {
              deferred.resolve(cached);
              return deferred.promise;
            }
            var options = {
              timeout: parameters.$timeout,
              method: 'GET',
              url: url,
              params: queryParameters,
              data: body,
              headers: headers
            };
            if (leanLawAuth.source) {
              options.headers['x-leanlaw-source'] = leanLawAuth.source;
            }
            queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
              options.headers['x-leanlaw-tag'] = parameters['createTag'];
            }
            if (Object.keys(form).length > 0) {
              options.data = form;
              options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
              options.transformRequest = leanLawApi.transformRequest;
            }

            auth().then(function(authResult) {
              if (authResult?.token) {
                options.headers['Authorization'] = 'Bearer ' + authResult.token;
              }
              $http(options).then(function(response) {
                if (response.status >= 400) {
                  deferred.reject({
                    status: response.status,
                    header: response.headers,
                    config: response.config,
                    body: response.data
                  });
                  return;
                }
                return deferred.resolve(response.data);
                if (parameters.$cache !== undefined) {
                  parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                }
              }, function(response) {
                return deferred.reject({
                  status: response.status,
                  headers: response.headers,
                  config: response.config,
                  body: response.data
                });
              });
            }, function(error) {
              deferred.reject({
                status: error
              });
            });

            return deferred.promise;
          };
          /**
           * Create planner entry
           * @method
           * @name leanLawApi#createEntry
           * @param {} body -
           *
           */
          leanLawApi.prototype.convertExternalEvent = function(parameters) {
            if (parameters === undefined) {
              parameters = {};
            }
            var deferred = $q.defer();

            var domain = this.domain;
            var path = '/externalTimeEvents';

            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};

            if (parameters['body'] !== undefined) {
              body = parameters['body'];
            }

            if (parameters.$queryParameters) {
              Object.keys(parameters.$queryParameters)
                .forEach(function(parameterName) {
                  var parameter = parameters.$queryParameters[parameterName];
                  queryParameters[parameterName] = parameter;
                });
            }

            var url = domain + path;
            var options = {
              timeout: parameters.$timeout,
              method: 'POST',
              url: url,
              params: queryParameters,
              data: body,
              headers: headers
            };
            if (leanLawAuth.source) {
              options.headers['x-leanlaw-source'] = leanLawAuth.source;
            }
            queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
              options.headers['x-leanlaw-tag'] = parameters['createTag'];
            }
            if (Object.keys(form).length > 0) {
              options.data = form;
              options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
              options.transformRequest = leanLawApi.transformRequest;
            }

            auth().then(function(authResult) {
              if (authResult?.token) {
                options.headers['Authorization'] = 'Bearer ' + authResult.token;
              }
              $http(options).then(function(response) {
                if (response.status >= 400) {
                  deferred.reject({
                    status: response.status,
                    header: response.headers,
                    config: response.config,
                    body: response.data
                  });
                  return;
                }
                return deferred.resolve(response.data);
                if (parameters.$cache !== undefined) {
                  parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                }
              }, function(response) {
                return deferred.reject({
                  status: response.status,
                  headers: response.headers,
                  config: response.config,
                  body: response.data
                });
              });
            }, function(error) {
              deferred.reject({
                status: error
              });
            });

            return deferred.promise;
          };
          /**
           * Delete a time entry
           * @method
           * @name leanLawApi#ignoreExternalEvents
           * @param {string} id -
           *
           */
          leanLawApi.prototype.ignoreExternalEvents = function(parameters) {
            if (parameters === undefined) {
              parameters = {};
            }
            var deferred = $q.defer();

            var domain = this.domain;
            var path = '/externalTimeEvents/{id}';

            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};

            path = path.replace('{id}', parameters['id']);

            if (parameters['id'] === undefined) {
              deferred.reject(new Error('Missing required parameter: id'));
              return deferred.promise;
            }

            if (parameters.$queryParameters) {
              Object.keys(parameters.$queryParameters)
                .forEach(function(parameterName) {
                  var parameter = parameters.$queryParameters[parameterName];
                  queryParameters[parameterName] = parameter;
                });
            }

            var url = domain + path;
            var options = {
              timeout: parameters.$timeout,
              method: 'DELETE',
              url: url,
              params: queryParameters,
              data: body,
              headers: headers
            };
            if (leanLawAuth.source) {
              options.headers['x-leanlaw-source'] = leanLawAuth.source;
            }
            queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
              options.headers['x-leanlaw-tag'] = parameters['createTag'];
            }
            if (Object.keys(form).length > 0) {
              options.data = form;
              options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
              options.transformRequest = leanLawApi.transformRequest;
            }

            auth().then(function(authResult) {
              if (authResult?.token) {
                options.headers['Authorization'] = 'Bearer ' + authResult.token;
              }
              $http(options).then(function(response) {
                if (response.status >= 400) {
                  deferred.reject({
                    status: response.status,
                    header: response.headers,
                    config: response.config,
                    body: response.data
                  });
                  return;
                }
                return deferred.resolve(response.data);
                if (parameters.$cache !== undefined) {
                  parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                }
              }, function(response) {
                return deferred.reject({
                  status: response.status,
                  headers: response.headers,
                  config: response.config,
                  body: response.data
                });
              });
            }, function(error) {
              deferred.reject({
                status: error
              });
            });

            return deferred.promise;
          };
          /**
           * Get the status of m365 connection
           * @method
           * @name leanLawApi#getExternalEventsConnectionStatus
           */
          leanLawApi.prototype.getExternalEventsConnectionStatus = function(parameters) {
            if (parameters === undefined) {
              parameters = {};
            }
            var deferred = $q.defer();

            var domain = this.domain;
            var path = '/externalTimeEvents/status';

            var body;
            var queryParameters = {};
            var headers = {};
            var form = {};

            if (parameters.$queryParameters) {
              Object.keys(parameters.$queryParameters)
                .forEach(function(parameterName) {
                  var parameter = parameters.$queryParameters[parameterName];
                  queryParameters[parameterName] = parameter;
                });
            }

            var url = domain + path;
            var cached = parameters.$cache && parameters.$cache.get(url);
            if (cached !== undefined && parameters.$refresh !== true) {
              deferred.resolve(cached);
              return deferred.promise;
            }
            var options = {
              timeout: parameters.$timeout,
              method: 'GET',
              url: url,
              params: queryParameters,
              data: body,
              headers: headers
            };
            if (leanLawAuth.source) {
              options.headers['x-leanlaw-source'] = leanLawAuth.source;
            }
            queryParameters['timeOffset'] = new Date().getTimezoneOffset();
                if (parameters['createTag']) {
              options.headers['x-leanlaw-tag'] = parameters['createTag'];
            }
            if (Object.keys(form).length > 0) {
              options.data = form;
              options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
              options.transformRequest = leanLawApi.transformRequest;
            }

            auth().then(function(authResult) {
              if (authResult?.token) {
                options.headers['Authorization'] = 'Bearer ' + authResult.token;
              }
              $http(options).then(function(response) {
                if (response.status >= 400) {
                  deferred.reject({
                    status: response.status,
                    header: response.headers,
                    config: response.config,
                    body: response.data
                  });
                  return;
                }
                return deferred.resolve(response.data);
                if (parameters.$cache !== undefined) {
                  parameters.$cache.put(url, response.data, parameters.$cacheItemOpts ? parameters.$cacheItemOpts : {});
                }
              }, function(response) {
                return deferred.reject({
                  status: response.status,
                  headers: response.headers,
                  config: response.config,
                  body: response.data
                });
              });
            }, function(error) {
              deferred.reject({
                status: error
              });
            });

            return deferred.promise;
          };
            return leanLawApi;
        })();

        return new leanLawApi();
    }]);
